/*
Copyright MITSUBISHI Elec.
*/

//---------------------------------------
// javascript 言語拡張
//---------------------------------------


/**
 * ## blendercommon
 * 共通ライブラリ
 *
 * @module blendercommon
 * @main blendercommon
 */

/**
 * Functionクラスを拡張。
 * blendercommon.jsをインポートする。
 *
 * @class Function
 */

/**
 * クラスを継承する。
 *
 * @method inherit
 * @param baseClass {class} ベースクラス
 */
Function.prototype.inherit = function (baseClass) {
	function tempClass() {}
	tempClass.prototype = baseClass.prototype;
	this.prototype = new tempClass;
	this.prototype.constructor = baseClass;
}

/**
 * AOP拡張: 関数の呼び出し前にcallback処理を実施する関数を作成し返す。
 *
 * @method addBefore
 * @param callback {function} 処理前呼び出し関数
 */
Function.prototype.addBefore = function (callback) {
	var self = this;
	return function() {
		if (jQuery.isFunction(callback)) {
			callback();
		}
		var res = self.apply(self, arguments);
		return res;
	}
}

/**
 * AOP拡張: 関数の呼び出し後にcallback処理を実施する関数を作成し返す。
 *
 * @method addAfter
 * @param callback {function} 処理後呼び出し関数
 */
Function.prototype.addAfter = function (callback) {
	var self = this;
	return function() {
		var res = self.apply(self, arguments);
		if (jQuery.isFunction(callback)) {
			callback();
		}
		return res;
	}
}

/**
 * Stringクラスを拡張。
 * blendercommon.jsをインポートする。
 *
 * @class String
 */

/**
 * 置換対象文字列を置換文字列に置き換える。
 *
 * @method replaceAll
 * @param org {string} 置換対象文字列
 * @param dest {string} 置換文字列
 * @return {string} 置換後文字列
 */
String.prototype.replaceAll = function(org, dest) {
	return this.split(org).join(dest);
}

/**
 * 文字列前後の空白を削除する。
 *
 * @method trim
 * @return {string} 空白削除後文字列
 */
String.prototype.trim = function() {
	return this.replace(/(^\s+|\s+$)/g, "");
}

/**
 * 指定した判定文字列から始まるか判定する。
 *
 * @method startsWith
 * @param str {string} 判定文字列
 * @return {boolean} True:判定文字列から始まる,False:始まらない
 */
String.prototype.startsWith = function(str) {
	if (str.length > this.length) return false;
	return this.indexOf(str) == 0;
}

/**
 * 指定した判定文字列で終わるか判定する。
 *
 * @method endsWith
 * @param str 判定文字列
 * @return {boolean} True:判定文字列で終わる,False:終わらない
 */
String.prototype.endsWith = function(str) {
	if (str.length > this.length) return false;
	return this.lastIndexOf(str) == (this.length - str.length);
}

/**
 * 汎用的共通関数群。
 * blendercommon.jsをインポートする。
 *
 * @class -
 */

/**
 * 指定したMouseEvent.buttonの値が左クリックか判定する。
 * IE9以降(0),IE8以前(1)
 *
 * [MouseEvent.button](https://developer.mozilla.org/ja/docs/Web/API/MouseEvent/button)
 * [Which mouse button has been clicked?](http://www.quirksmode.org/js/events_properties.html#button)
 *
 * @method isBtnLeft
 * @param button {number} MouseEvent.button
 * @return {boolean} True:左クリック,False:左クリック以外
 */
function isBtnLeft(button) {
	var btnLeft = ((window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8) && typeof(window.addEventListener) == "undefined" ? 1:0) // 1 for IE8-
	// ie-11 in ie-7 mode
	if (window.dhx4.isIE && navigator.userAgent.indexOf("MSIE 7.0") >= 0 && navigator.userAgent.indexOf("Trident") >= 0) {
		btnLeft = 1;
	}
	return (button==btnLeft);
}

/**
 * オブジェクトが文字列か否か判定する。
 *
 * @method isString
 * @param obj {object} オブジェクト
 * @return {boolean} オブジェクトが文字列の場合true、文字列でない場合false
 */
function isString(obj){
	return (typeof obj == "string");
}

/**
 * オブジェクトが数値か否か判定する。
 *
 * @method isNumber
 * @param obj {object} オブジェクト
 * @return {boolean} オブジェクトが数値の場合true、数値でない場合false
 */
function isNumber(obj){
	return (!isNaN(obj));
}

/**
 * オブジェクトが数値文字列(0-9.,-)か否か判定する。
 *
 * @method isNumberStr
 * @param obj {object} オブジェクト
 * @return {boolean} オブジェクトが数値文字列(0-9.,-)の場合true、数値文字列でない場合false
 */
function isNumberStr(obj){
	return (obj ? obj.match(/^[0-9|.|,|-]*$/) : false);
}

/**
 * オブジェクトが配列か否か判定する。
 *
 * @method isArray
 * @param obj {object} オブジェクト
 * @return {boolean} オブジェクトが配列の場合true、配列でない場合false
 */
function isArray(obj){
	return (typeof obj == "object") && (obj instanceof Array);
}

/**
 * 空データか否か判定する。
 *
 * @method isEmpty
 * @param obj {object} オブジェクト
 * @return {boolean} オブジェクトが空データの場合true、空データでない場合false
 */
function isEmpty(obj){
	var ret;
	if( isString(obj) ) {
		ret = (obj.toString().length == 0);
	}else if( isArray(obj) ) {
		ret = (obj.length == 0)
	}else {
		ret = (obj==null);
	}
	return ret;
}


//---------------------------------------
// jQuery 拡張
//---------------------------------------

jQuery.fn.extend({
	savedVal: function( value ) {
		if ( value === undefined ) {
			return this.attr("_savedValue");
		}else {
			this.attr("_savedValue", value);
		}
	}
});

//---------------------------------------
// BLEnDer 汎用定数定義
//---------------------------------------

/**
 * BLEnDer汎用定数定義クラス。
 *
 * @class BlenderConstants
 */

/**
 * 権限種別:権限なし
 * @property {string} AUTHORITY_TYPE_NONE
 * @static
 * @final
 */
BlenderConstants.AUTHORITY_TYPE_NONE  = "0";
/**
 * 権限種別:参照のみ
 * @property {string} AUTHORITY_TYPE_SHOW_ONRY
 * @static
 * @final
 */
BlenderConstants.AUTHORITY_TYPE_SHOW_ONRY = "1";
/**
 * 権限種別:参照/編集可能
 * @property {string} AUTHORITY_TYPE_SHOW_AND_EDIT
 * @static
 * @final
 */
BlenderConstants.AUTHORITY_TYPE_SHOW_AND_EDIT = "2";

/**
 * アクション種別:汎用
 * @property {string} ACTION_TYPE_GENERAL
 * @static
 * @final
 */
BlenderConstants.ACTION_TYPE_GENERAL = "general";
/**
 * アクション種別:参照
 * @property {string} ACTION_TYPE_SHOW
 * @static
 * @final
 */
BlenderConstants.ACTION_TYPE_SHOW = "show";
/**
 * アクション種別:更新
 * @property {string} ACTION_TYPE_REGIST
 * @static
 * @final
 */
BlenderConstants.ACTION_TYPE_REGIST = "regist";
/**
 * アクション種別:未定(権限設定の影響を受けない)
 * @property {string} ACTION_TYPE_SUSPENSE
 * @static
 * @final
 */
BlenderConstants.ACTION_TYPE_SUSPENSE = "suspense";

function BlenderConstants() {
}

/**
 * システム汎用定数定義クラス。
 *
 * @class SystemConstants
 */

/**
 * Ajaxエラーコード: システムエラー
 * @property {string} AJAX_RESULT_SYSTEM_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_SYSTEM_ERROR = "-1";
/**
 * Ajaxエラーコード: 成功
 * @property {string} AJAX_RESULT_SUCCESS
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_SUCCESS = "0";
/**
 * Ajaxエラーコード: 精査エラー
 * @property {string} AJAX_RESULT_VALID_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_VALID_ERROR = "1";
/**
 * Ajaxエラーコード: アプリインフォ
 * @property {string} AJAX_RESULT_APP_INFO
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_APP_INFO = "95";
/**
 * Ajaxエラーコード: 対象データ消失エラー
 * @property {string} AJAX_RESULT_ENTITY_NOT_FOUND
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_ENTITY_NOT_FOUND = "96";
/**
 * Ajaxエラーコード: ステータス変更時レコードロックによるエラー
 * @property {string} AJAX_RESULT_STATUS_CHANGE_LOCK_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_STATUS_CHANGE_LOCK_ERROR = "97";
/**
 * Ajaxエラーコード: ステータス変更エラー
 * @property {string} AJAX_RESULT_STATUS_CHANGE_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_STATUS_CHANGE_ERROR = "98";
/**
 * Ajaxエラーコード: アプリエラー
 * @property {string} AJAX_RESULT_APP_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_RESULT_APP_ERROR = "99";

/**
 * Ajaxサブエラーコード: エラー
 * @property {string} AJAX_SUB_RESULT_ERROR
 * @static
 * @final
 */
SystemConstants.AJAX_SUB_RESULT_ERROR = "1";
/**
 * Ajaxサブエラーコード: 警告
 * @property {string} AJAX_SUB_RESULT_WARN
 * @static
 * @final
 */
SystemConstants.AJAX_SUB_RESULT_WARN = "2";

function SystemConstants() {
}

//---------------------------------------
//BlenderComponent カスタム基本設定
//---------------------------------------

/**
* 入力フィールドセット日本語対応。
*/
BlenderCustomSettings.calendarPanelLangData = {
	jp:{
		weekLabels:			["日","月","火","水","木","金","土"],
		weekClasses:		["SUN","MON","TUE","WED","THU","FRI","SAT"],
		monthLabelFormat:	"%Y年 %c月",
		weekStart:			0
	}
}

/**
* 入力フィールドセット日本語対応。
*/
BlenderCustomSettings.inputFieldSetLangData = {
	jp:{
		searchBtnLabel:	"検索",
		cancelBtnLabel:	"取消"
	}
}

/**
* 条件パネル用コンポーネント日本語対応。
*/
BlenderCustomSettings.conditionPanelLangData = {
	jp:{
		option1Label:	"一致",
		option2Label:	"不一致",
		showBtnLabel:	"表示",
		labelDatetime:	"yyyy/mm/dd hh:mm:ss",
		symbolBetween:	"～",
		symbolRequired:	"*",
		symbolSeparator:	"："
	}
}

/**
 * メッセージダイアログ日本語対応
 */
BlenderCustomSettings.messageBoxDialogLangData = {
	jp:{
		infoLabel:	"情報",
		warnLabel:	"警告",
		questionLabel:	"確認",
		errorLabel:	"エラー",
		clipCopyBtnLabel: "クリップボードにコピー",
		okBtnLabel:	"ＯＫ",
		yesBtnLabel:	"はい",
		noBtnLabel:	"いいえ",
		cancelBtnLabel:	"キャンセル",
		detailShowBtnLabel:	"詳細を表示",
		detailHiddenBtnLabel:	"詳細を隠す"
	}
}

/**
 * 入力ダイアログ日本語対応
 */
BlenderCustomSettings.promptBoxDialogLangData = {
	jp: {
		okBtnLabel: "ＯＫ",
		cancelBtnLabel: "キャンセル",
		defaultErrMsg: "入力内容が不正です。"
	}
}

/**
* ウィンドウマネージャクラスコンポーネント日本語対応。
*/
BlenderDhtmlxCustomSettings.windowManagerLangData = {
	jp:{
		titleDelim:		" ― ",
		subTitleDelim:	" ： "
	}
}

function BlenderCustomSettings() {
}

//---------------------------------------
//dHtml基本設定
//(dHtmlx標準で、Localizing対応しているもの)
//---------------------------------------

/**
* カレンダーコンポーネント日本語対応。
*/
BlenderDhtmlxCustomSettings.langData = {
	jp:{
		dateformat:	"%Y/%m/%d",
		hdrformat:	"%Y年 %F",
		monthesFNames:	["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
		monthesSNames:	["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
		daysFNames:	["日", "月", "火", "水", "木", "金", "土"],
		daysSNames:	["日", "月", "火", "水", "木", "金", "土"],
		weekstart:	7,
		weekname:	"週"
	}
}

/**
* カラーピッカーコンポーネント日本語対応。
*/
BlenderDhtmlxCustomSettings.colorPickerLangData = {
	jp:{
		labelHue:	"色相",
		labelSat:	"彩度",
		labelLum:	"輝度",
		labelRed:	"Red",
		labelGreen:	"Green",
		labelBlue:	"Blue",
		btnAddColor:	"追加",
		btnSelect:	"選択",
		btnCancel:	"キャンセル"
	}
}

/**
* グリッド日本語対応。
*/
BlenderDhtmlxCustomSettings.gridLangData = {
	loading: "Loading",
	decimal_separator:".",
	group_separator:",",
	jp:{
		selectBtnLabel:	"選択",
		clearBtnLabel:	"クリア",
		runBtnLabel:	"実行"
	}
}

function BlenderDhtmlxCustomSettings() {
}

//---------------------------------------
// ユーティリティ関数
//---------------------------------------

/**
 * ユーティリティクラス。
 *
 * @module blendercommon
 * @class BlenderUtil
 */

/**
 * コンディション:有効
 * @property {string} BTN_CONDITION_ENABLE
 * @static
 * @final
 */
BlenderUtil.BTN_CONDITION_ENABLE  = "1";
/**
 * コンディション:無効
 * @property {string} BTN_CONDITION_DISABLE
 * @static
 * @final
 */
BlenderUtil.BTN_CONDITION_DISABLE = "2";

/**
 * マージ2ルール：置換(配列要素を同じindexの要素と置換する)
 * @property {number} MERGE2_RULE_REPLACE
 * @static
 * @final
 */
BlenderUtil.MERGE2_RULE_REPLACE = 1;
/**
 * マージ2ルール：追加(配列要素を追加する)
 * @property {number} MERGE2_RULE_ADD
 * @static
 * @final
 */
BlenderUtil.MERGE2_RULE_ADD = 2;
/**
 * 埋め込みパラメータカスタムタグの既定のID
 * @property {string} DEFAULT_ID_EMBEDDED_PARAMS
 * @static
 * @final
 */
BlenderUtil.DEFAULT_ID_EMBEDDED_PARAMS = "blenderEmbeddedParams";

/** リクエストパラメータ */
BlenderUtil.reqParams = null;
/** リクエストパラメータ数 */
BlenderUtil.reqParamLength = 0;

function BlenderUtil() {
}

/**
 * ボタンコンディションを固定する。
 *
 * @method markBtnConditionFixed
 * @param target {object|string} ボタンを示すjqueryオブジェクト or タグSelector
 */
BlenderUtil.markBtnConditionFixed = function(target) {
	if( isString(target) ) {
		target = $(target);
	}
	target.each(function(){
		var obj = $(this);
		obj.attr("cond_fixed", "cond_fixed");
	});
}

/**
 * ボタンコンディションの固定を解除する。
 *
 * @method removeBtnConditionFixed
 * @param target {object|string} ボタンを示すjqueryオブジェクト or タグSelector
 */
BlenderUtil.removeBtnConditionFixed = function(target) {
	if( isString(target) ) {
		target = $(target);
	}
	target.each(function(){
		var obj = $(this);
		obj.removeAttr("cond_fixed");
	});
}

/**
 * ボタンコンディションを変更する。
 * この際、ボタンのアクション属性を考慮し、
 * 権限に基づいた制御を行う。(現在は権限未考慮)
 *
 * @method changeBtnCondition
 * @param target {object|string} ボタンを示すjqueryオブジェクト or タグSelector
 * @param condition {string} コンディション(BlenderConstants.AUTHORITY_TYPE_*)
 * @param force {boolean} 強制フラグ(trueの場合condition_fixed指定を解除して状態変更)
 */
BlenderUtil.changeBtnCondition = function(target, condition, force) {
	if( isString(target) ) {
		target = $(target);
	}

	var userRole = window["userRole"];
	if( !userRole ) {
		userRole = BlenderConstants.AUTHORITY_TYPE_NONE;
	}

	target.each(function(){
		var obj = $(this);

		var actType = obj.attr("actionType");
		if( !actType ) {
			actType = BlenderConstants.ACTION_TYPE_SUSPENSE;
		}

		if( force ) {
			obj.removeAttr("cond_fixed");
		}

		if( !obj.attr("cond_fixed") && (actType!=BlenderConstants.ACTION_TYPE_SUSPENSE) ) {
			// 状態固定されておらず、アクション種別が
			// ACTION_TYPE_SUSPENSE以外の場合は処理対象

			if( condition == BlenderUtil.BTN_CONDITION_ENABLE ) {
				// 権限により有効化はコントロール
				if( userRole == BlenderConstants.AUTHORITY_TYPE_SHOW_ONRY ) {
					// 参照のみの場合
					if( actType == BlenderConstants.ACTION_TYPE_GENERAL
					 || actType == BlenderConstants.ACTION_TYPE_SHOW ) {
						obj.removeAttr("disabled");
					}
				}else if( userRole == BlenderConstants.AUTHORITY_TYPE_SHOW_AND_EDIT ) {
					// 参照/編集可の場合
					obj.removeAttr("disabled");
				}else {
					// 権限なしの場合:画面が表示されないのでNOP
				}
			}else if( condition == BlenderUtil.BTN_CONDITION_DISABLE ) {
				// ACTION_TYPE_SUSPENSE以外どのアクション種別でも無効化はok
				obj.attr("disabled", "disabled");
			}
		}
		return true;
	});
}

/**
 * フォーカストラバーサルを設定する。
 * タグに設定されたtabIndexに基づきフォーカス設定を行う。
 * blendergrid をフォーカストラバーサルに含める場合は、
 * gridの元になるDIVタグにtabIndexを設定する。
 * 本処理の対象となるのはtabIndexに0より大きな値が設定されていた
 * 場合であり、0は対象外となるので注意のこと。
 * なおdefaultFocusを設定することで当該要素に最初のフォーカスを当てる。
 *
 * @method setupFocusTraversal
 */
BlenderUtil.setupFocusTraversal = function(target) {
	var tags = [];
	$("[tabIndex!='0']").each(function(){
		if(this.tabIndex===0 || this.tabIndex===-1) return;
		tags[tags.length] = this;
	});

	if( tags.length==0 ) return;

	tags.sort(function(a,b){
		return parseInt(a.getAttribute("tabIndex")) - parseInt(b.getAttribute("tabIndex"));
	});

	var defaultFocusObj = $(tags[0]);

	for( var i=0; i<tags.length; i++ ) {
		var obj = $(tags[i]);
		if( obj.attr("defaultFocus") ) {
			defaultFocusObj = obj;
		}

		var nextNode = (null!=tags[i+1] ? tags[i+1] : tags[0]);
		var prevNode = (null!=tags[i-1] ? tags[i-1] : tags[tags.length-1]);

		//alert(tags[i].tagName+"["+tags[i].id+"] tabIndex = "+tags[i].getAttribute("tabIndex")+", prev: "+prevNode.id+", next: "+nextNode.id);

		if( tags[i].tagName == "DIV" ) {
			//alert( tags[i].id );
			var objInfo = BlenderObjectManager.getObject(tags[i].id);
			if( objInfo ) {
				if( objInfo[0]=="grid" ) {
					var grid = objInfo[1];
					grid.enableEditTabOnly(true);
					grid.setExternalTabOrder(prevNode.id,nextNode.id);
				}else {
					alert("未知のオブジェクト種別です。type: "+objInfo[0]);
				}
			}else {
				alert("ID: "+tags[i].id+" に対応するオブジェクトがマネージャに登録されていません。");
			}
		}
	}

	defaultFocusObj.focus();
}

/**
 * ドキュメント要素にバックスペースキー無効化処理を設定する。
 * これによりテキストフィールド、パスワードフィールド、テキストエリア以外から
 * 発生されるバックスペースキーイベントを抑制し、「前ページに戻る」処理を
 * 実施させないようにすることができる。
 *
 * ->非推奨
 * BlenderUserInput.setupDisableUserInput()を使用ください。
 *
 * @method setupDisableBackspace
 * @deprecated Use BlenderUserInput.setupDisableUserInput()
 */
BlenderUtil.setupDisableBackspace = function() {
	BlenderUserInput.setupDisableUserInput();
}

/**
 * ブラウザの横幅を取得する。
 *
 * @method getBrowserWidth
 * @return {number} ブラウザの横幅
 */
BlenderUtil.getBrowserWidth = function() {
	if ( window.innerWidth ) {
		return window.innerWidth;
	}else if ( document.documentElement && document.documentElement.clientWidth != 0 ) {
		return document.documentElement.clientWidth;
	}else if ( document.body ) {
		return document.body.clientWidth;
	}
	return 0;
}

/**
 * ブラウザの高さを取得する。
 *
 * @method getBrowserHeight
 * @return {number} ブラウザの高さ
 */
BlenderUtil.getBrowserHeight = function() {
	if ( window.innerHeight ) {
		return window.innerHeight;
	}else if ( document.documentElement && document.documentElement.clientHeight != 0 ) {
		return document.documentElement.clientHeight;
	}else if ( document.body ) {
		return document.body.clientHeight;
	}
	return 0;
}

/**
 * リクエストパラメータの有無を確認する。
 *
 * @method hasRequestParams
 * @return {boolean} リクエストパラメータが存在する場合true。
 */
BlenderUtil.hasRequestParams = function() {
	BlenderUtil.parseRequestParams();
	return BlenderUtil.reqParamLength>0;
}

/**
 * リクエストパラメータを取得する。
 *
 * @method getRequestParam
 * @param key {object} リクエストパラメータのキー
 * @return {object} リクエストパラメータの値
 */
BlenderUtil.getRequestParam = function(key) {
	BlenderUtil.parseRequestParams();
	return BlenderUtil.reqParams[key];
}

/**
 * リクエストパラメータを解析する。
 *
 * @method parseRequestParams
 */
BlenderUtil.parseRequestParams = function() {
	if( BlenderUtil.reqParams===null ) {
		BlenderUtil.reqParams = {};

		var tmp = [];
		if( document.URL.lastIndexOf("?") > 0 ) {
			tmp = document.URL.substr(document.URL.lastIndexOf("?")+1).split("&");
		}
		for( var i=0; i<tmp.length; i++ ) {
			var reqParam = tmp[i].split("=");
			if (/^dhxr\d+$/.test(reqParam[0])) {
				// dhtmlxのキャッシュ防止パラメータ("dhxr"＋数字)を無視
				continue;
			}
		}
		for( var i=0; i<tmp.length; i++ ) {
			var reqParam = tmp[i].split("=");
			BlenderUtil.reqParams[reqParam[0]] = reqParam[1];
			BlenderUtil.reqParamLength++;
		}
	}
}

/**
 * javascript により動的に変更が加えられたhtmlソースを表示する。
 *
 * @method showDynamicHtml
 */
BlenderUtil.showDynamicHtml = function() {
	javascript:void(window.open('', '', 'scrollbars=yes,dependent=yes').document.write(
		'<plaintext>' + document.body.innerHTML));
}

/**
 * 指定した文字を全角か半角か判定する。
 * (漢字コードがShift_JISの場合)
 *
 * @method isTwoByteCharCode
 * @param value {string} 値
 * @return {boolean} 全角の場合true、半角の場合false
 */
BlenderUtil.isTwoByteCharCode = function(value) {
	for (var i = 0; i < value.length; ++i) {
		var c = value.charCodeAt(i);
		if (c < 256 || (c >= 0xff61 && c <= 0xff9f)) {
			//半角の場合
			return false;
		}
	}
	//全角の場合
	return true;
}

/**
 * 指定した文字がmultibyteか判定する。
 * (UTF-8の場合)
 *
 * @method isMultiByteCharCode
 * @param value {string} Unicode文字
 * @return {boolean} multibyteの場合true、1byteの場合false
 */
BlenderUtil.isMultiByteCharCode = function(value) {
	for (var i = 0; i < value.length; ++i) {
		var c = value.charCodeAt(i);
		if (c <= 0x7f) {
			//1byteの場合
			return false;
		}
	}
	//multibyteの場合
	return true;
}

/**
 * 指定したマルチバイト文字を含む文字列のバイト数を取得する。
 * (UTF-8の場合)
 *
 * @method lengthMultiBytes
 * @param value {string} 文字列(UTF-8)
 * @return {number} バイト数
 */
BlenderUtil.lengthMultiBytes = function(value) {
	return (encodeURIComponent(value).replace(/%../g,"x").length);
}

/**
 * 指定した2つのオブジェクトをマージする。
 *
 * @method merge
 * @param obj1 {object} オブジェクト(1)
 * @param obj2 {object} オブジェクト(2)
 * @return {object} オブジェクト(1)と(2)の情報をマージしたオブジェクト
 */
BlenderUtil.merge = function(obj1, obj2) {
	var ret = {}
	for( var key in obj1 ) {
		ret[key] = obj1[key];
	}
	for( var key in obj2 ) {
		ret[key] = obj2[key];
	}
	return ret;
}

/**
 * 指定した2つのオブジェクトをマージする。
 *
 * @method merge2
 * @param obj1 {object} オブジェクト(1)
 * @param obj2 {object} オブジェクト(2)
 * @param deepFlag {boolean} ディープフラグ(trueの場合、多重階層を意思して処理する。)
 * @param ruleMap {object} マージ2ルール。
 *        ex.{"/@key1/":BlenderUtil.MERGE2_RULE_ADD}
 *           連想配列に"key1"という名前で格納された配列をマージする際、追加で処理する。
 *        ex.{"/@key1/[0]/":BlenderUtil.MERGE2_RULE_REPLACE}
 *           連想配列に"key1"という名前で格納された配列のindex=1に格納された配列を
 *           マージする際、置換で処理する。
 * @return {object} オブジェクト(1)と(2)の情報をマージしたオブジェクト
 */
BlenderUtil.merge2 = function(obj1, obj2, deepFlag, ruleMap) {
	ruleMap = ruleMap || {};

	var ret = {};
	if (Object.prototype.toString.apply(obj1) === '[object Array]') {
		ret = [];
	}

	BlenderUtil._merge2("/", ret, obj1, deepFlag, {});
	BlenderUtil._merge2("/", ret, obj2, deepFlag, ruleMap);

	return ret;
}

/**
 * merge2 内部処理。
 * @param name 名前
 * @param obj1 オブジェクト(1)
 * @param obj2 オブジェクト(2)
 * @param deepFlag ディープフラグ(trueの場合、多重階層を意思して処理する。)
 * @param ruleMap マージ2ルール。
 *        ex.{"/@key1/":BlenderUtil.MERGE2_RULE_ADD}
 *           連想配列に"key1"という名前で格納された配列をマージする際、追加で処理する。
 *        ex.{"/@key1/[0]/":BlenderUtil.MERGE2_RULE_REPLACE}
 *           連想配列に"key1"という名前で格納された配列のindex=1に格納された配列を
 *           マージする際、置換で処理する。
 * @return オブジェクト(2)をマージしたオブジェクト(1)。
 */
BlenderUtil._merge2 = function(name, obj1, obj2, deepFlag, ruleMap) {

	var mergeRule = ruleMap[name];
	if( !mergeRule ) {
		mergeRule = BlenderUtil.MERGE2_RULE_REPLACE;
	}

	var arrayFlag = false;
	if (Object.prototype.toString.apply(obj2) === '[object Array]') {
		arrayFlag = true;
	}

	//println("["+name+"] mergeRule: "+mergeRule);

	for ( var key in obj2 ) {
		var newName = name + (arrayFlag ? "[" + key + "]" : "@" + key);
		var src  = obj1[ key ];
		var copy = obj2[ key ];

		//println(newName+"の処理を実施。");

		if ( src === copy ) {
			continue;
		}

		if( mergeRule == BlenderUtil.MERGE2_RULE_REPLACE ) {
			// key はそのまま
		}else if( mergeRule == BlenderUtil.MERGE2_RULE_ADD ) {
			key = obj1.length;
		}

		if ( deepFlag && copy && typeof copy === "object" && !copy.nodeType ) {
			obj1[ key ] = BlenderUtil._merge2(
				newName + "/",
				src || ( copy.length != null ? [ ] : { } ),
				copy,
				deepFlag,
				ruleMap
			);
		}else if ( copy !== undefined ) {
			obj1[ key ] = copy;
		}
	}
	return obj1;
}

/**
 * オブジェクトのクローンを作成する。
 *
 * @method clone
 * @param obj {object} オブジェクト
 * @param deepFlag {boolean} ディープフラグ(ディープコピーをする場合はtrue、シャローコピーをする場合はfalse)
 * @return {object} オブジェクトを複製したオブジェクト
 */
BlenderUtil.clone = function(obj, deepFlag) {
	var ret;

	if( isArray(obj) ) {
		ret = [];
	}else {
		ret = {};
	}

	if(deepFlag){
		$.extend(true,ret,obj);
	}else {
		$.extend(ret,obj);
	}
	return ret;
}

/**
 * オブジェクトから指定したプロパティ名の値を取得する。
 *
 * @method getPropValue
 * @param obj {object} オブジェクト
 * @param propName {string} プロパティ名(ex. "xxx.yyy.zzz[0]")
 */
BlenderUtil.getPropValue = function(obj, propName) {
	var propNameArray = propName.split(".");
	return BlenderUtil._getPropValue(obj, propNameArray, 0);
}

/**
 * オブジェクトから指定したプロパティ名の値を取得する。
 * @param obj オブジェクト
 * @param propNameArray プロパティ名配列
 * @param nameIndex プロパティ名インデックス
 */
BlenderUtil._getPropValue = function(obj, propNameArray, nameIndex) {
	if( !obj ) return null;

	var propName = propNameArray[nameIndex];
	var valueIndex = -1;

	var tmpIndex = propName.indexOf("[");
	if( tmpIndex>=0 ) {
		valueIndex = Number(propName.substring(tmpIndex+1, propName.indexOf("]")));
		propName = propName.substring(0, tmpIndex);
	}
	//alert("propName: "+propName+", valueIndex: "+valueIndex);

	var ret = null;
	if( !isEmpty(propName) ) {
		ret = (valueIndex==-1 ? obj[propName] : obj[propName][valueIndex]);
		if( (propNameArray.length-1) > nameIndex ) {
			ret = BlenderUtil._getPropValue(ret, propNameArray, nameIndex+1);
		}
	}else {
		alert("不正データ, propName: "+propNameArray.join("."));
	}
	return ret;
}

/**
 * オブジェクトの指定したプロパティに値を設定する。
 *
 * @method setPropValue
 * @param obj {object} オブジェクト
 * @param propName {string} プロパティ名(ex. "xxx.yyy.zzz[0]")
 * @param val {object} 値
 */
BlenderUtil.setPropValue = function(obj, propName, val) {
	var propNameArray = propName.split(".");
	BlenderUtil._setPropValue(obj, propNameArray, 0, val);
}

/**
 * オブジェクトの指定したプロパティに値を設定する。
 * @param obj オブジェクト
 * @param propNameArray プロパティ名配列
 * @param nameIndex プロパティ名インデックス
 * @param val 値
 */
BlenderUtil._setPropValue = function(obj, propNameArray, nameIndex, val) {
	var propName = propNameArray[nameIndex];
	var valueIndex = -1;

	var tmpIndex = propName.indexOf("[");
	if( tmpIndex>=0 ) {
		valueIndex = Number(propName.substring(tmpIndex+1, propName.indexOf("]")));
		propName = propName.substring(0, tmpIndex);
	}
	//alert("propName: "+propName+", valueIndex: "+valueIndex);

	if( !isEmpty(propName) ) {
		if( (propNameArray.length-1) > nameIndex ) {
			if( valueIndex==-1 ) {
				BlenderUtil._setPropValue(obj[propName], propNameArray, nameIndex+1, val);
			}else {
				BlenderUtil._setPropValue(obj[propName][valueIndex], propNameArray, nameIndex+1, val);
			}
		}else {
			if( valueIndex==-1 ) {
				obj[propName] = val;
			}else {
				obj[propName][valueIndex] = val;
			}
		}
	}else {
		alert("不正データ, propName: "+propNameArray.join("."));
	}
}

/**
 * 指定した年度内の月次処理を実施する。
 * yearに2011を指定した場合、コールバック関数の
 * 引数には 2011/4-12, 2012/1-3 が渡される。
 *
 * @method procMonthlyLogic
 * @param year {string|number} 年度
 * @param callback {function} コールバック関数(引数1:index(0-11)、引数2:年、引数3:月)
 */
BlenderUtil.procMonthlyLogic = function(_year, callback) {
	if (jQuery.isFunction(callback)) {
		var year = parseInt(_year);

		for( var i=0; i<12; i++ ) {
			var targetMonth = (i<=8 ? i+4 : i-8);
			var targetYear = (targetMonth>=4 ? year : year+1);
			callback(i, targetYear, targetMonth);
		}
	}
}

/**
 * パラメータを置換したメッセージを生成する。
 *
 * @method createMessage
 * @param base {string} 置換前メッセージ
 * @param params {string|array} パラメータ
 * @return {string} パラメータを置換したメッセージ
 */
BlenderUtil.createMessage = function(base, params) {
	var ret = base;

	var tempParams = null;
	if (isString(params)) {
		tempParams = [params];
	} else if (isArray(params)) {
		tempParams = params;
	}

	if (null != tempParams) {
		for (var i = 0; i < tempParams.length; i++) {
			ret = ret.replaceAll("{" + i + "}", tempParams[i]);
		}
	}

	return ret;
}

/**
 * コンボボックスの選択ハンドラを設定する。
 * 本関数を用いて設定を行った場合、画面の編集有無を確認し、
 * 変更があった場合にデータを破棄していいか確認するようになる。
 * (「はい」でハンドラ(execFunc)を実行、「いいえ」でキャンセルする)
 *
 * @method setupComboHandler
 * @param combo {object} BlenderComboオブジェクト
 * @param execFunc {object} 選択ハンドラ
 */
BlenderUtil.setupComboChangeHandler = function(combo, execFunc) {
	if( combo._bl_setuped ) {
		alert("既に設定済のComboが指定されました。(id: "+$(combo.cont).attr("id")+")");
		return;
	}

	combo.attachEvent("onOpen", function(){
		this._bl_value = this.getSelectedIndex();
	});
	combo.attachEvent("onChange", function(value, text){
		if( isDirty() && !isIgnoreDirty() ) {
			var thisCombo = this;
			var yesFunc = function(){
				setIgnoreDirty(true);
				execFunc();
			}
			var noFunc = function(){
				thisCombo.block();
				thisCombo.selectOption(thisCombo._bl_value);
				thisCombo.unblock();
			}
			checkDirtyClean(yesFunc, noFunc);
		}else {
			execFunc();
		}
	});
	combo._bl_setuped = true;

}

/**
 * 画面埋め込みパラメータ(カスタムタグ &lt;bhtml:embededd /&gt;)の値を取得する。
 *
 * @method getEmbededParamValues
 * @param {string} id 埋め込みパラメータカスタムタグのid属性値。カスタムタグにid属性を設定していないならば引数無し。
 * @return {object} jsonデータ { "name値": "入力値", ... }
 */
BlenderUtil.getEmbededParamValues = function(id) {
	"use strict";
	id = id || BlenderUtil.DEFAULT_ID_EMBEDDED_PARAMS;
	var ret = {};

	$("#" + id).children("input").each(function(i, e) {
		var n = e.name, v = e.value, r = ret[n];

		if ($.isArray(r)) {
			r.push(v);
		} else {
			ret[n] = r ? [ r, v ] : v;
		}
	});
	return ret;
};

/**
 * 対象の要素を名前付きの枠で囲む
 *
 * @method createNamedPanel
 * @param id {string|HTMLElement|JQuery} 枠で囲む対象のID、要素あるいはJQueryインスタンス
 * @param legend {string} 名前付き枠に表示する文字列。省略時は対象の要素のdata-logical-name属性の値を使用する。
 */
BlenderUtil.createNamedPanel = function(id, legend) {
	"use strict";
	var $target;

	if (isString(id)) {
		$target = $("#" + id);

		if (!$target.get(0)) {
			throw Error("指定したIDの要素が存在しません [" + id + "]");
		}
	} else {
		$target = $(id);
		id = $target.attr("id");
	}
	$target.attr("id", (id + "_wrapper")).addClass("namedPanel");

	legend = legend || $target.data("logicalName") || " ";

	// フィールドセットを作成
	var $fieldset = $("<fieldset/>")
			.append($("<legend/>").text(legend));

	// 内側のDIVを作成
	$("<div/>")
			.attr("id", id)
			.addClass("inner")
			.append($target.children())
			.appendTo($fieldset);

	$target.append($fieldset);
};


//---------------------------------------
// 日付ユーティリティ
//---------------------------------------

/**
 * 日付ユーティリティクラス。
 *
 * @class BlenderDateUtil
 */
function BlenderDateUtil() {
}

/**
 * デフォルト日付フォーマット(%Y/%m/%d)
 * @property {string} DEFAULT_DATE_FORMAT
 * @static
 * @final
 */
BlenderDateUtil.DEFAULT_DATE_FORMAT = "%Y/%m/%d";

/**
 * 日付オブジェクトを文字列に変換する。
 * フォーマット
 * 年: 2桁(%y), 4桁(%Y)
 * 月: 1桁(%c), 2桁(%m)
 * 日: 1桁(%e), 2桁(%d)
 * 時: 2桁(%h)
 * 分: 2桁(%M)
 * 秒: 2桁(%s)
 * 曜日: (%W)
 *
 * @method formatDate
 * @param date {object|string|number} 日付オブジェクト
 * @param dateformat {string} フォーマット
 * @return {string} 変換後文字列
 */
BlenderDateUtil.formatDate = function (date, dateformat) {
	if(!date) {
		return null;
	}

	if(!dateformat) {
		dateformat = BlenderDateUtil.DEFAULT_DATE_FORMAT;
	}

	date = new Date(date);
	if( isNaN( date.getTime() ) ) {
		return  null;
	}

	var out = '';
	var plain = true;
	for (var i=0;i<dateformat.length;i++){
		var replStr = dateformat.substr(i, 1);
		if (plain){
			if (replStr == '%'){
				plain = false;
				continue
			};
			out += replStr
		}else {
			switch (replStr) {
				case 'y':
					replStr = date.getFullYear();
					replStr = replStr.toString().substr(2);
					break;
				case 'Y':
					replStr = date.getFullYear()
					break;
				case 'c':
					replStr = 1 + date.getMonth();
					break;
				case 'm':
					replStr = 1 + date.getMonth();
					if (replStr.toString().length == 1) {
						replStr = '0' + replStr;
					}
					break;
				case 'e':
					replStr = date.getDate();
					break;
				case 'd':
					replStr = date.getDate();
					if (replStr.toString().length == 1)
						replStr='0'+replStr;
					break;
				case 'h':
					replStr = date.getHours();
					if (replStr.toString().length == 1) {
						replStr = '0' + replStr;
					}
					break;
				case 'M':
					replStr = date.getMinutes();
					if (replStr.toString().length == 1) {
						replStr = '0' + replStr;
					}
					break;
				case 's':
					replStr = date.getSeconds();
					if (replStr.toString().length == 1) {
						replStr = '0' + replStr;
					}
					break;
				case 'j':
					var x = new Date(date.getFullYear(), 0, 0, 0, 0, 0, 0);
					replStr = Math.ceil((date.valueOf() - x.valueOf())/1000/60/60/24 - 1);
					while (replStr.toString().length < 3) {
						replStr = '0' + replStr;
					}
					break;
				case 'W':
					replStr = BlenderDhtmlxCustomSettings.langData['jp'].daysFNames[date.getDay()];
					break;
			};
			out += replStr;
			plain = true;
		}
	};
	return out
}

/**
 * 文字列を日付オブジェクトに変換する。
 *
 * @method parseDate
 * @param date {string} 日付文字列
 * @param dateformat {string} フォーマット
 * @return {date} 日付オブジェクト
 */
BlenderDateUtil.parseDate = function(date, dateformat){
	if( !date || !isString(date) ) {
		return date;
	}

	if( !dateformat ) {
		dateformat = BlenderDateUtil.DEFAULT_DATE_FORMAT;
	}
	// "yyyy/MM/dd HH:mm" 形式の分解に対応したため、コメントアウト
	//date = date.split(" ")[0];

	var outputDate = new Date(2008, 0, 1);
	var j=0;
	for(var i=0;i<dateformat.length;i++){
		var _char = dateformat.charAt(i);
		if(_char=="%"){
			var _cd = dateformat.charAt(i+1);
			var _nextpc = dateformat.indexOf("%",i+1);
			var _nextDelim = dateformat.substr(i+2,_nextpc-i-1-1);
			var _nDelimInDatePos = date.indexOf(_nextDelim,j);

			if(_nextDelim=="") {
				_nDelimInDatePos = date.length;
			}
			if(_nDelimInDatePos==-1) {
				return null;
			}

			var value = date.substr(j, _nDelimInDatePos-j);
			if (_cd != 'M' && _cd != 'b') {
				value -= 0;
			}
			j=_nDelimInDatePos+_nextDelim.length;
//alert(_cd+", "+value);
			switch (_cd) {
				case 'Y':
					outputDate.setFullYear(parseFloat(value));
					break;
				case 'y':
					var year=parseFloat(value);
					outputDate.setFullYear(((year>20)?1900:2000) + year);
					break
				case "m":
				case "c":
					outputDate.setMonth(parseFloat(value) - 1);
					break;
				case 'd':
				case 'e':
					outputDate.setDate(parseFloat(value));
					break;
				case 'h':
					outputDate.setHours(parseFloat(value));
					break;
				case 'M':
					outputDate.setMinutes(parseFloat(value));
					break;
				case 's':
					outputDate.setSeconds(parseFloat(value));
					break;
			}
		}
	};
//	alert(">>"+dateformat+" - "+outputDate);

	return !isNaN(outputDate) ? outputDate : null;
}

/**
 * 日付文字列に指定日数を加算した日付文字列を取得する。
 *
 * @method addDate
 * @param date {string|date} 日付文字列
 * @param amount {number} 加算日数
 * @param dateformat {string} フォーマット
 * @return {string} 加算変換後文字列
 */
BlenderDateUtil.addDate = function(date, amount, dateformat){
	if( !date ) {
		return null;
	}

	if( isString(date) ) {
		date = BlenderDateUtil.parseDate(date, dateformat);
	}

	var baseVal = date.getTime();

	date.setTime(baseVal + (amount * (24 * 60 * 60 * 1000)));

	return BlenderDateUtil.formatDate(date, dateformat);
}

//---------------------------------------
// 色ユーティリティ
//---------------------------------------

/**
 * 色ユーティリティクラス。
 *
 * @class BlenderColorUtil
 */
function BlenderColorUtil() {
}

/**
 * RGB to YUV変換
 *
 * @method rgbToYuv
 * @param data {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 * @return {array} YUV {y:輝度信号,u:色差信号(Cb),v:色差信号(Cr)}
 */
BlenderColorUtil.rgbToYuv = function(data){
	return {y:data.r * 0.299 + data.g * 0.587 + data.b * 0.114,
			u:data.r * -0.169 - data.g * - 0.331 + data.b * 0.500,
			v:data.r * 0.500 - data.g * 0.419 - data.b * 0.081};
}

/**
 * YUV to RGB変換
 *
 * @method yuvToRgb
 * @param data {array} YUV {y:輝度信号, u:色差信号(Cb), v:色差信号(Cr)}
 * @return {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 */
BlenderColorUtil.yuvToRgb = function(data){
	return {r:data.y * 1.000 + data.v * 1.402,
			g:data.y * 1.000 - data.u * 0.344 - data.v * 0.714,
			b:data.y * 1.000 + data.u * 1.772};
}

/**
 * 背景色に最適な文字色(白・黒)をYUVの輝度と透明度を元に取得する。
 *
 * @method getFontColorByYUV
 * @param data {array} RGB/RGBA {r:赤色(0-255),g:緑色(0-255),b:青色(0-255),a:透明度(0.0-1.0)}
 * @return {string} white/black
 */
BlenderColorUtil.getFontColorByYUV = function(data){
	var yuv = BlenderColorUtil.rgbToYuv(data);
	var bColor = (yuv.y > 127) ? "black" : "white";
	if (data.a!=null&&(data.a>=0&&data.a<=0.3)) bColor = "black";
	return bColor;
}

/**
 * RGB(HEX) to RGB(数値)変換
 *
 * @method hexToRgb
 * @param str {string} RGB(HEX)
 * @return {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 */
BlenderColorUtil.hexToRgb = function(str) {
	var data = str.match(/^(#)([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
	if (data != null) {
		return {
			r: parseInt("0x"+data[2]),
			g: parseInt("0x"+data[3]),
			b: parseInt("0x"+data[4])
		};
	} else {
		return null;
	}
}

/**
 * RGB(数値) to RGB(HEX)変換
 *
 * @method rgbToHex
 * @param data {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 * @return {string} RGB(HEX)
 */
BlenderColorUtil.rgbToHex = function(data) {
	var r = parseInt(data.r), g = parseInt(data.g), b = parseInt(data.b);
	r = r||0, g = g||0, b = b||0;
	return "#"+((r)? ((r<16)? "0"+r.toString(16):r.toString(16)): "00") +((g)? ((g<16)? "0"+g.toString(16):g.toString(16)): "00") +((b)? ((b<16)? "0"+b.toString(16):b.toString(16)): "00");
}

/**
 * RGB(数値) to HSL変換
 *
 * @method rgbToHsl
 * @param data {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 * @return {array} HSL {H:色相(0-255),S:彩度(0-255),b:青色(0-255)}
 */
BlenderColorUtil.rgbToHsl = function(data) {
	var H, S, L;
	var r = data.r;
	var g = data.g;
	var b = data.b;
	var max = Math.max(r,g,b), min = Math.min(r,g,b);

	//** L **
	L = 0.5*(max + min);

	//** H **
	if (max == min) H = 0;
	else if (max == r) {
		H = 60*(g - b)/(max-min);
		if (g < b) H += 360;
	} else if (max == g) H = 60*(b - r)/(max - min) + 120;
	else H = 60*(r-g)/(max - min) + 240;

	//** S **
	if (L == 0 || max == min) S = 0;
	else if (L <= 0.5) S = 0.5*(max - min)/L;
	else S = 0.5*(max - min)/(1 - L);

	return {
		h: H,
		s: S,
		l: L
	};
}

/**
 * HSL to RGB(数値)変換
 *
 * @method hslToRgb
 * @param data {array} HSL {H:色相(0-255),S:彩度(0-255),b:青色(0-255)}
 * @return {array} RGB {r:赤色(0-255),g:緑色(0-255),b:青色(0-255)}
 */
BlenderColorUtil.hslToRgb = function(data) {
	var Q,P,_H;
	var T = [], RGB = [];
	var H = data.H;
	var S = data.S;
	var L = data.L;

	// ** Q **
	if (L <= 0.5) Q = L*(1+S);
	else Q = L + S - (L*S);

	//** P **
	P = 2*L - Q;

	//** H ***
	_H = H/360;

	T.push(_H + 1/3);
	T.push(_H);
	T.push(_H - 1/3);

	for (var i = 0; i<3; i++) {
		if (T[i]<0) T[i] += 1;
		else if (T[i]>1) T[i] -= 1;

		if (T[i] < 1/6) RGB.push(P + (Q - P)*6*T[i]);
		else if (T[i] < 0.5) RGB.push(Q);
		else if (T[i] < 2/3) RGB.push(P + (Q - P)*(2/3 - T[i])*6);
		else RGB.push(P);
	}

	return {
		r: RGB[0],
		g: RGB[1],
		b: RGB[2]
	};
}

/**
 * 透過度付RGB(HEX) to RGBA(数値)変換
 *
 * @method hexaToRgba
 * @param str {string} 透過度付RGB(HEX) ex) #FFFFFF,1.0
 * @return {array} RGBA {r:赤色(0-255),g:緑色(0-255),b:青色(0-255),a:透過度(0.0-1.0}
 */
BlenderColorUtil.hexaToRgba = function(str){
	var rgb = null;
	if( null!=str ) {
		var tmp = str.split(",");
		rgb = BlenderColorUtil.hexToRgb(tmp[0]);
		if( rgb ) {
			rgb.a = (null!=tmp[1] ? parseFloat(tmp[1]) : 1.0);
		}
	}
	return rgb;
}

/**
 * RGBA(数値) to 透過度付RGB(HEX)変換
 *
 * @method rgbaToHexa
 * @param data {array} RGBA {r:赤色(0-255),g:緑色(0-255),b:青色(0-255),a:透過度(0.0-1.0}
 * @return {string} 透過度付RGB(HEX) ex) #FFFFFF,1.0
 */
BlenderColorUtil.rgbaToHexa = function(data){
	if( null!=data ) return BlenderColorUtil.rgbToHex(data)+","+(data.a ? data.a : 1.0).toFixed(1);
	else return "";
}

/**
 * RGBA(数値) to RGBA(文字列)変換
 *
 * @method rgbaToRgbaStr
 * @param rgba {array} RGBA {r:赤色(0-255),g:緑色(0-255),b:青色(0-255),a:透過度(0.0-1.0}
 * @return {string} rgba文字列 ex) "rgba(255,255,255,1.0)"
 */
BlenderColorUtil.rgbaToRgbaStr = function(rgba){
	if( null!=rgba ) return "rgba("+rgba.r+","+rgba.g+","+rgba.b+","+rgba.a+")";
	else return null;
}

/**
 * カラーネーム:HEX
 *
 */
BlenderColorUtil.COLOR_NAME_TO_HEX =
{
	"white":"#FFFFFF", "whitesmoke":"#F5F5F5", "ghostwhite":"#F8F8FF", "aliceblue":"#F0F8FF", "lavendar":"#E6E6FA", "azure":"#F0FFFF",
	"lightcyan":"#E0FFFF", "mintcream":"#F5FFFA", "honeydew":"#F0FFF0", "ivory":"#FFFFF0", "beige":"#F5F5DC", "lightyellow":"#FFFFE0",
	"lightgoldenrodyellow":"#FAFAD2", "lemonchiffon":"#FFFACD", "floralwhite":"#FFFAF0", "oldlace":"#FDF5E6", "cornsilk":"#FFF8DC",
	"papayawhite":"#FFEFD5", "blanchedalmond":"#FFEBCD", "bisque":"#FFE4C4", "snow":"#FFFAFA", "linen":"#FAF0E6", "antiquewhite":"#FAEBD7",
	"seashell":"#FFF5EE", "lavenderblush":"#FFF0F5", "mistyrose":"#FFE4E", "gainsboro":"#DCDCDC", "lightgray":"#D3D3D3", "lightsteelblue":"#B0C4DE",
	"lightblue":"#ADD8E6", "lightskyblue":"#87CEFA", "powderblue":"#B0E0E6", "paleturquoise":"#AFEEEE", "skyblue":"#87CEEB", "mediumaquamarine":"#66CDAA",
	"aquamarine":"#7FFFD4", "palegreen":"#98FB98", "lightgreen":"#90EE90", "khaki":"#F0E68C", "palegoldenrod":"#EEE8AA", "moccasin":"#FFE4B5",
	"navajowhite":"#FFDEAD", "peachpuff":"#FFDAB9", "wheat":"#F5DEB3", "pink":"#FFC0CB", "lightpink":"#FFB6C", "thistle":"#D8BFD8",
	"plum":"#DDA0DD", "silver":"#C0C0C0", "darkgray":"#A9A9A9", "lightslategray":"#778899", "slategray":"#708090", "slateblue":"#6A5ACD",
	"steelblue":"#4682B4", "mediumslateblue":"#7B68EE", "royalblue":"#4169E", "blue":"#0000FF", "dodgerblue":"#1E90FF", "cornflowerblue":"#6495ED",
	"deepskyblue":"#00BFFF", "cyan":"#00FFFF", "aqua":"#00FFFF", "turquoise":"#40E0D0", "mediumturquoise":"#48D1CC", "darkturquoise":"#00CED",
	"lightseagreen":"#20B2AA", "mediumspringgreen":"#00FA9A", "springgreen":"#00FF7F", "lime":"#00FF00", "limegreen":"#32CD32", "yellowgreen":"#9ACD32",
	"lawngreen":"#7CFC00", "chartreuse":"#7FFF00", "greenyellow":"#ADFF2F", "yellow":"#FFFF00", "gold":"#FFD700", "orange":"#FFA500",
	"darkorange":"#FF8C00", "goldenrod":"#DAA520", "burlywood":"#DEB887", "tan":"#D2B48C", "sandybrown":"#F4A460", "darksalmon":"#E9967A",
	"lightcoral":"#F08080", "salmon":"#FA8072", "lightsalmon":"#FFA07A", "coral":"#FF7F50", "tomato":"#FF6347", "orangered":"#FF4500",
	"red":"#FF0000", "deeppink":"#FF1493", "hotpink":"#FF69B4", "palevioletred":"#DB7093", "violet":"#EE82EE", "orchid":"#DA70D6",
	"magenta":"#FF00FF", "fuchsia":"#FF00FF", "mediumorchid":"#BA55D3", "darkorchid":"#9932CC", "darkviolet":"#9400D3", "blueviolet":"#8A2BE2",
	"mediumpurple":"#9370DB", "gray":"#808080", "mediumblue":"#0000CD", "darkcyan":"#008B8B", "cadetblue":"#5F9EA0", "darkseagreen":"#8FBC8F",
	"mediumseagreen":"#3CB37", "teal":"#008080", "forestgreen":"#228B22", "seagreen":"#2E8B57", "darkkhaki":"#BDB76B", "peru":"#CD853F",
	"crimson":"#DC143C", "indianred":"#CD5C5C", "rosybrown":"#BC8F8F", "mediumvioletred":"#C71585", "dimgray":"#696969", "black":"#000000",
	"midnightblue":"#191970", "darkslateblue":"#483D8B", "darkblue":"#00008B", "navy":"#000080", "darkslategray":"#2F4F4F", "green":"#008000",
	"darkgreen":"#006400", "darkolivegreen":"#556B2F", "olivedrab":"#6B8E23", "olive":"#808000", "darkgoldenrod":"#B8860B", "chocolate":"#D2691E",
	"sienna":"#A0522D", "saddlebrown":"#8B4513", "firebrick":"#B22222", "brown":"#A52A2A", "maroon":"#800000", "darkred":"#8B0000",
	"darkmagenta":"#8B008B", "purple":"#800080", "indigo":"#4B0082"
};

//---------------------------------------
// BlenderComponent群 基盤
//---------------------------------------

/**
 * ## BlenderComponent
 * Blenderコンポーネントクラス。
 *
 * modifyCheckerなどの機構に対応する。
 *
 * @module BlenderComponent
 * @main BlenderComponent
 */

/**
 * Blenderコンポーネントクラス。
 *
 * @class BlenderComponent
 * @constractor
 * @module BlenderComponent
 * @param id {string}
 * @param skin {string} スキン名
 */
function BlenderComponent(id, skin) {
	this.tagId = id;
	this.skin = skin;
	this.handlers = {};
}

/**
 * スキンを設定する。
 *
 * @method setSkin
 * @param skin {string} スキン名
 */
BlenderComponent.prototype.setSkin = function(skin) {
	this.skin = skin;
}

/**
 * イベントハンドラを設定する。
 *
 * @method attachEvent
 * @param type {string} イベント種別("valueChanged")
 * @param func {function} イベントハンドラ
 */
BlenderComponent.prototype.attachEvent = function(type,func) {
	var handlerArray = this.handlers[type];
	if( !handlerArray ) {
		handlerArray = [];
	}
	handlerArray[handlerArray.length] = func;
	this.handlers[type] = handlerArray;
}

/**
 * イベントを通知する。
 * @param e 通知するイベント
 */
BlenderComponent.prototype._notifyEvent = function(e) {
	var ret = true;
	var handlerArray = this.handlers[e.type];
	if( handlerArray ) {
		//alert("handlerArray.length:"+handlerArray.length);
		for( var i=0; i<handlerArray.length; i++ ) {
			handlerArray[i](e);
			//handlerArray[i].apply(this,arguments);
			if( e.consume==true ) {
				ret = false;
				break;
			}
		}
	}
	return ret;
}

//---------------------------------------
// オブジェクトマネージャ
//---------------------------------------

/** オブジェク配列 */
BlenderObjectManager.objs = {}

/**
 * Blenderオブジェクトマネージャ
 *
 * @class BlenderObjectManager
 */
function BlenderObjectManager(){
}

/**
 * オブジェクトを登録する。
 *
 * @method putObject
 * @param id {string} ID
 * @param obj {object} オブジェクト
 * @param type {string} オブジェクト種別
 */
BlenderObjectManager.putObject = function(id, obj, type) {
	BlenderObjectManager.objs[id] = [type, obj];
}

/**
 * 指定したIDに対応するオブジェクト情報を取得する。
 *
 * @method getObject
 * @param id {string} ID
 * @return {array} オブジェクト情報(配列 [0]:オブジェクト種別、[1]:オブジェクト)
 */
BlenderObjectManager.getObject = function(id) {
	return BlenderObjectManager.objs[id];
}

/**
 * 指定したオブジェクト種別に対応するオブジェクト配列を取得する。
 *
 * @method getObjectsByType
 * @param type {string} オブジェクト種別
 * @return {array} オブジェクト配列
 */
BlenderObjectManager.getObjectsByType = function(type) {
	var ret = [];

	for(var key in BlenderObjectManager.objs) {
		var objInfo = BlenderObjectManager.objs[key];
		if( objInfo[0] == type ) {
			ret[ret.length] = objInfo[1];
		}
	}
	return ret;
}

//---------------------------------------
// BlenderRadioGroup
//---------------------------------------

/**
 * ##BlenderRadioGroup
 *
 * @class BlenderRadioGroup
 * @constractor
 * @module BlenderRadioGroup
 * @param selector {string} タグSelector
 */
function BlenderRadioGroup(selector){
	this.targetObjs = [];
	this._savedVal = null;

	var self = this;

	$(selector).each(function(){
		self.targetObjs[self.targetObjs.length] = $(this);
	});
}

/**
 * 値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 *
 * @method val
 * @param value {object} 値
 * @return {object} 値
 */
BlenderRadioGroup.prototype.val = function(value) {
	if ( arguments.length == 0 ) {
		var val;
		for( var i=0; i<this.targetObjs.length; i++ ) {
			if( this.targetObjs[i].prop("checked") ) {
				val = this.targetObjs[i].val();
				break;
			}
		}
		return val;
	}else {
		if ( value === undefined ) {
			for( var i=0; i<this.targetObjs.length; i++ ) {
				if( this.targetObjs[i].prop("checked") ) {
					this.targetObjs[i].prop("checked", false);
					break;
				}
			}
		} else {
			for( var i=0; i<this.targetObjs.length; i++ ) {
				if( this.targetObjs[i].val() == value ) {
					this.targetObjs[i].prop("checked", true);
					break;
				}
			}
		}
	}
}

/**
 * 保存値を取得/設定する。
 * ※BlenderModifyChecker対応用メソッド
 *
 * @method savedVal
 * @param value {object} 値
 * @return {object} 値
 */
BlenderRadioGroup.prototype.savedVal = function(value) {
	if ( arguments.length == 0 ) {
		return this._savedVal;
	}else {
		this._savedVal = value;
	}
}

/**
 * 値変更イベントハンドラを設定する。
 * ※BlenderModifyChecker対応用メソッド
 *
 * @method change
 * @param func {function} 値変更イベントハンドラ
 */
BlenderRadioGroup.prototype.change = function(func) {
	for( var i=0; i<this.targetObjs.length; i++ ) {
		this.targetObjs[i].change(func);
	}
}

/**
 * クラスの有無を確認する。
 * ※BlenderModifyChecker対応用メソッド
 *
 * @method hasClass
 * @param className {string} クラス名
 * @return {boolean} True:クラス有,False:クラス無
 */
BlenderRadioGroup.prototype.hasClass = function(className) {
	var ret = true;
	for( var i=0; i<this.targetObjs.length; i++ ) {
		ret &= this.targetObjs[i].hasClass(className);
	}
	return ret;
}

/**
 * クラスを追加する。
 * ※BlenderModifyChecker対応用メソッド
 *
 * @method addClass
 * @param className {string} クラス名
 */
BlenderRadioGroup.prototype.addClass = function(className) {
	for( var i=0; i<this.targetObjs.length; i++ ) {
		this.targetObjs[i].addClass(className);
	}
}

/**
 * クラスを削除する。
 *
 * ※BlenderModifyChecker対応用メソッド
 * @param className クラス名
 */
BlenderRadioGroup.prototype.removeClass = function(className) {
	for( var i=0; i<this.targetObjs.length; i++ ) {
		this.targetObjs[i].removeClass(className);
	}
}

//---------------------------------------
// メッセージボックス
//---------------------------------------

/** メッセージ種別: 情報 */
BlenderMessageBox.MSG_TYPE_INFO     = 1;
/** メッセージ種別: 警告 */
BlenderMessageBox.MSG_TYPE_WARN     = 2;
/** メッセージ種別: 確認 */
BlenderMessageBox.MSG_TYPE_QUESTION = 3;
/** メッセージ種別: エラー */
BlenderMessageBox.MSG_TYPE_ERROR    = 4;

/** オプションラベル */
BlenderMessageBox.OPTION_LABEL = ["okBtnLabel","yesBtnLabel","noBtnLabel","cancelBtnLabel","detailShowBtnLabel"];

/** オプションセット: デフォルト */
BlenderMessageBox.OPTION_DEFAULT       = [true,false,false,false,false];
/** オプションセット: YES/NO */
BlenderMessageBox.OPTION_YES_NO        = [false,true,true,false,false];
/** オプションセット: YES/NO/キャンセル */
BlenderMessageBox.OPTION_YES_NO_CANCEL = [false,true,true,true,false];
/** オプションセット: OK/キャンセル */
BlenderMessageBox.OPTION_OK_CANCEL     = [true,false,false,true,false];
/** オプションセット: キャンセル */
BlenderMessageBox.OPTION_CANCEL        = [false,false,false,true,false];

/** TabIndex のオフセット */
BlenderMessageBox.TAB_INDEX_OFFSET = 1000;

/** イメージパス */
BlenderMessageBox._imagePath = "codebase/blender/imgs";
/** メッセージボックス */
BlenderMessageBox._msgBox = null;
/** 処理関数 */
BlenderMessageBox._func = [null, null, null, null, null];
/** クローズフラグ(ボタン押下時にダイアログクローズを行うかを示すフラグ。true:クローズする) */
BlenderMessageBox._closeFlg = [true, true, true, true, false];

/**
 * メッセージボックス
 *
 * @module BlenderComponent
 * @class BlenderMessageBox
 */
function BlenderMessageBox() {
}

/**
 * メッセージボックスを表示する。
 *
 * @method show
 * @param {Hash} param メッセージボックスパラメータ(以下のキーを持つ連想配列)
 *              "title":     タイトル
 *              "msg":       メッセージ本文
 *              "msgParam":  メッセージ本文パラメータ
 *              "detailMsg": 詳細メッセージ本文
 *              "type":      メッセージ種別(MSG_TYPE_*)
 *              "option":    オプションセット(OPTION_*)
 *              "width":     ウィンドウ幅
 *              "height":    ウィンドウ高
 *              "detailWidth": 詳細メッセージ表示時のウィンドウ幅
 *              "detailHeight": 詳細メッセージ表示時のウィンドウ高
 *              "ok":        ok選択時のコールバック関数
 *              "yes":       yes選択時のコールバック関数
 *              "no":        no選択時のコールバック関数
 *              "cancel":    cancel選択時のコールバック関数
 *              "skin":      skin(省略時:blender)
 *              "optionLabel": ボタンのキー名(ok,yes,no,cancel,detail)とそこに割り当てるラベル名の
 *                           連想配列を指定する。省略時はボタン毎のデフォルト値となる。
 *              　　　　　　　ex) optionにBlenderMessageBox.OPTION_OK_CANCELを指定時、OKボタンの銘を"実行"に変える場合
 *              　　　　　　　　　{"ok":"実行"}
 *              "optionFocus": 初期フォーカスを与えるボタンのキー名(ok,yes,no,cancel,detail)を指定する。
 *              　　　　　　　ex) "yes"
 *              "lang": ボタンに表示する言語(デフォルト,jp:日本語)
 * @return メッセージダイアログをjQueryオブジェクト
 */
BlenderMessageBox.show = function(param) {

	var msgBox = BlenderMessageBox.createMsgBoxDialog(param);

	BlenderMessageBox.buildMsgBoxContent(msgBox, param);

	BlenderMessageBox._msgBox = msgBox;

	return $(msgBox);
}

/**
 * メッセージボックスのウィンドウ枠を作成する。
 * ※本メソッドおよび BlenderMessageBox.isShowing を置き換えることで
 * dHtmlXWindow などを元にしたメッセージボックスも作成可能。
 *
 * @param param メッセージボックスパラメータ(内容はshow関数参照)
 * @return メッセージボックスのウィンドウ枠
 */
BlenderMessageBox.createMsgBoxDialog = function(param) {

	var msgBox = new BlenderMessageBoxDialog(param);
	msgBox.init();

//	var msgBox = parent.openModalDialog("msgBox", "確認", 400, 150, userRole);
//	msgBox.setIconCss("flag_blue");

	return msgBox;

}

/**
 * 指定されたメッセージボックスにコンテンツを作成する。
 *
 * @param msgBox メッセージボックス
 * @param param メッセージボックスパラメータ(内容はshow関数参照)
 */
BlenderMessageBox.buildMsgBoxContent = function(msgBox, param) {
	var msg = param["msg"] || "";
	var msgParam = param["msgParam"] || [];
	var detailMsg = param["detailMsg"] || null;
	var type = param["type"] || BlenderMessageBox.MSG_TYPE_INFO;
	var option = param["option"];
	var msgWidth = param["width"] || 400;
	var msgHeight = param["height"] || 150;
	var detailWidth = param["detailWidth"] || msgWidth;
	var detailHeight = param["detailHeight"] || msgHeight+300;
	var wSkin = param["skin"] || "blender";

	var detailAreaTop = 20;

	BlenderMessageBox._func[0] = param["ok"];
	BlenderMessageBox._func[1] = param["yes"];
	BlenderMessageBox._func[2] = param["no"];
	BlenderMessageBox._func[3] = param["cancel"];

	var optionLabel = [];
	for(var k=0;k<BlenderMessageBox.OPTION_LABEL.length;k++){
		optionLabel[k] = msgBox.i18n[msgBox.lang][BlenderMessageBox.OPTION_LABEL[k]]
	}
	var optionLabelTmp = param["optionLabel"];
	if (optionLabelTmp) {
		optionLabel = [
			optionLabelTmp.ok     || optionLabel[0],
			optionLabelTmp.yes    || optionLabel[1],
			optionLabelTmp.no     || optionLabel[2],
			optionLabelTmp.cancel || optionLabel[3],
			optionLabelTmp.detail || optionLabel[4]
		];
	}

	msg = BlenderUtil.createMessage(msg, msgParam);

	if( type == BlenderMessageBox.MSG_TYPE_INFO ) {
		option = (option ? option : BlenderMessageBox.OPTION_DEFAULT);
	}else if( type == BlenderMessageBox.MSG_TYPE_WARN ) {
		option = (option ? option : BlenderMessageBox.OPTION_DEFAULT);
	}else if( type == BlenderMessageBox.MSG_TYPE_QUESTION ) {
		option = (option ? option : BlenderMessageBox.OPTION_YES_NO);
	}else if( type == BlenderMessageBox.MSG_TYPE_ERROR ) {
		option = (option ? option : BlenderMessageBox.OPTION_DEFAULT);
	}

	// 詳細メッセージがあれば、詳細表示ボタンを有効にする。
	if( detailMsg ) {
		option[4] = true;
	}else {
		option[4] = false;
	}

	var focusTarget = 0;
	var optionFocusTmp = param["optionFocus"];
	if (!optionFocusTmp) {
		if( option == BlenderMessageBox.OPTION_DEFAULT ) {
			focusTarget = 0;
		}else if( option == BlenderMessageBox.OPTION_YES_NO ) {
			focusTarget = 2;
		}else if( option == BlenderMessageBox.OPTION_YES_NO_CANCEL ) {
			focusTarget = 3;
		}else if( option == BlenderMessageBox.OPTION_OK_CANCEL ) {
			focusTarget = 3;
		}else if( option == BlenderMessageBox.OPTION_CANCEL ) {
			focusTarget = 3;
		}
	}else {
		if (optionFocusTmp == "ok" && option[0]){
			focusTarget = 0;
		} else if (optionFocusTmp == "yes" && option[1]) {
			focusTarget = 1;
		} else if (optionFocusTmp == "no" && option[2]) {
			focusTarget = 2;
		} else if (optionFocusTmp == "cancel" && option[3]) {
			focusTarget = 3;
		} else if (optionFocusTmp == "detail" && option[4]) {
			focusTarget = 4;
		}
	}

	var msgArea = $("<div id='bl_MsgAreaDiv' style='position:absolute;top:10px;left:15px;width:"+(msgWidth-40)+"px;height:"+(msgHeight-90)+"px;overflow:auto'>"+msg+"</div>");
	var btnArea = $("<div id='bl_MsgBtnAreaDiv' style='position:absolute;top:"+(msgHeight-75)+"px;left:20px;width:"+(msgWidth-40)+"px;margin-right:5px;'></div>");

	var msgBoxHolder = new BlenderMessageBoxHolder(msgBox, msgWidth, msgHeight, detailWidth, detailHeight);
	BlenderMessageBox._func[4] = msgBoxHolder.showDetail; // 詳細表示用ボタンの設定

	var btns = [null,null,null,null,null];
	for( var i=(option.length-1); i>=0; i-- ) {
		if( option[i] ) {
			btns[i] = $("<input type='button' class='blender-button' />");
			btns[i].val(optionLabel[i]);
			if( BlenderMessageBox._closeFlg[i] ) {
				btns[i].click(msgBoxHolder.hide);
			}
			if( BlenderMessageBox._func[i] ) {
				var wrapping = function(func){
					return function(){
						func.apply(this, arguments)
					}
				}
				btns[i].click(wrapping(BlenderMessageBox._func[i]));
			}
		}
	}
	for( var i=(option.length-1); i>=0; i-- ) {
		if( option[i] ) {
			if( BlenderMessageBox._closeFlg[i] ) {
				btns[i].click(msgBoxHolder.close);
			}
			btnArea.append(btns[i]);
		}
	}
	for( var i=0; i<btns.length; i++ ) {
		if( btns[i] ) {
			var leftBtn = null;
			var rightBtn = null;
			for( var j=i-1; j>=0; j-- ) {
				if( btns[j] ) {
					leftBtn = btns[j];
					break;
				}
			}
			for( var j=i+1; j<btns.length; j++ ) {
				if( btns[j] ) {
					rightBtn = btns[j];
					break;
				}
			}
			var keyHolder = new BlenderMessageBoxKeyHolder(leftBtn,rightBtn);
			btns[i].keyup(keyHolder.keyup);
			btns[i].attr("tabindex", BlenderMessageBox.TAB_INDEX_OFFSET+i);
		}
	}

	var detailMsgArea = $("<div style='position:absolute;top:"+((msgHeight-75)+(25-detailAreaTop))+"px;width:"+(msgWidth-50)+"px;height:"+((detailHeight-(msgHeight-95))-(145-detailAreaTop))+"px;overflow:auto;margin-bottom:100px;background-color:white;border:1px solid #91A7B4;padding:3px;white-space:nowrap'>");
	detailMsgArea.html(detailMsg);

	var clipCopyBtnLabel = msgBox.i18n[msgBox.lang].clipCopyBtnLabel;
	var clipCopyBtn = $("<input type='button' value='" + clipCopyBtnLabel + "' class='blender-button' style='float:left;margin-left:0px;width:150px'>");
	clipCopyBtn.click(msgBoxHolder.copyDetail);
	clipCopyBtn.attr("tabindex", BlenderMessageBox.TAB_INDEX_OFFSET+btns.length);

	var detailBtnArea = $("<div style='position:absolute;top:120px;'>");
	detailBtnArea.append(clipCopyBtn);

	var detailArea = $("<div id='bl_DetailAreaDiv' style='position:absolute;top:"+detailAreaTop+"px;left:15px;display:none;margin-right:15px'></div>");
	detailArea.append("<hr style='position:absolute;top:90px;'>");
	detailArea.append(detailMsgArea);
	detailArea.append(detailBtnArea);

	var contBody = $("<div id='dhxmaincont' style='position:relative;top:0px;left:0px;width:"+(msgWidth-16)+"px;height:"+(msgHeight-40)+"px;overflow:hidden'>")
		.append(msgArea)
		.append(btnArea)
		.append(detailArea);

	if( btns[focusTarget] ) {
		setTimeout(function(){
			btns[focusTarget].focus();
		},10);
	}

	msgBox.attachObject(contBody[0]);
}

/**
 * メッセージボックスのイメージパスを設定する。
 *
 * @method setImagePath イメージパス(相対)
 * @param path イメージパス
 */
BlenderMessageBox.setImagePath = function(path) {
	BlenderMessageBox.imagePath = path;
}

/**
 * ->非推奨
 * BlenderUtil.createMessageを使用ください。
 *
 * パラメータを置換したメッセージを生成する。
 *
 * @param base 置換前メッセージ
 * @param params パラメータ
 * @return パラメータを置換したメッセージ
 */
BlenderMessageBox.createMessage = function(base, params) {
	return BlenderUtil.createMessage(base, params);
}

/**
 * メッセージボックスのサイズを変更する。
 *
 * @param msgBox メッセージボックス
 * @param newWidth 新規幅
 * @param newHeight 新規高
 * @param showDetailFlg 詳細メッセージを表示するかを示すフラグ(true:表示する)
 */
BlenderMessageBox.setSize = function(msgBox, newWidth, newHeight, showDetailFlg) {

	var bodyPanel = $("#bodyPanel");

	var parentWidth = bodyPanel.width();
	var parentHeight = bodyPanel.height();

	var dim = msgBox.getDimension();

	newWidth = newWidth || dim[0];
	newHeight = newHeight || dim[1];

	var wSkin;

	if( msgBox instanceof BlenderMessageBoxDialog ) {
		wSkin = msgBox.msgBoxDiv[0].className.substring(11);
	}else {
		wSkin = msgBox.conf.skin;
	}

	var newTop = (parentHeight/2) - (newHeight/2);
	var newLeft = (parentWidth/2) - (newWidth/2);

	var wBrdLeft = 1;
	var wBrdTop = 30;
	var wBrdWidthOffset = -14;
	var wBrdHeightOffset = -36;
	if(wSkin == "dhx_web"){
		wBrdTop = 28;
	}else
	if(wSkin == "material"){
		wBrdLeft = 0;
		wBrdWidthOffset = -6;
		wBrdHeightOffset = -34;
	}

	var contBody;

	if( msgBox instanceof BlenderMessageBoxDialog ) {

		msgBox.msgBoxDiv.css("top", newTop+"px");
		msgBox.msgBoxDiv.css("left", newLeft+"px");
		msgBox.msgBoxDiv.css("width", newWidth+"px");
		msgBox.msgBoxDiv.css("height", newHeight+"px");
		msgBox.msgBoxDiv.css("background-color", "rgba(0,0,0,0.0)");

		var outer = msgBox.msgBoxDiv.children(":eq(0)");
		outer.css("width", (newWidth-2)+"px");
		outer.css("height", (newHeight-2)+"px");

		var innner = outer.children(":eq(5)");
		innner.css("width", (newWidth-16)+"px");
		innner.css("height", (newHeight-40)+"px");

		var win_brd = outer.find(".dhxwin_brd");
		win_brd.css("left", wBrdLeft+"px");
		win_brd.css("width", (newWidth+wBrdWidthOffset)+"px");
		win_brd.css("height", (newHeight+wBrdHeightOffset)+"px");

		contBody = outer.find("#dhxmaincont");

	}else {

		msgBox.setDimension(newWidth, newHeight);
		msgBox.center();

		contBody = $(msgBox.cell.childNodes[msgBox.conf.idx.cont]).find("#dhxmaincont");

	}

	contBody.css("width", (newWidth-16)+"px");
	contBody.css("height", (newHeight-40)+"px");

//	var msgArea = contBody.find("#bl_MsgAreaDiv");
//	msgArea.css("width", (newWidth-40)+"px");
//	msgArea.css("height", (newHeight-95)+"px");

	var detailArea = contBody.find("#bl_DetailAreaDiv");
	if( showDetailFlg ) {
		detailArea.css("display", "block");
	}else {
		detailArea.css("display", "none");
	}

//	var detailMsgArea = detailArea.children(":eq(1)");
//	detailMsgArea.css("width", (newWidth-50)+"px");
//	detailMsgArea.css("height", (newHeight-200)+"px");

	var detailBtnArea = detailArea.children(":eq(2)");
	detailBtnArea.css("top", (newHeight-90)+"px");
}

/**
 * 表示中のメッセージボックスが(１つでも)存在するか判定する。
 * 引数 msg が指定された場合は、そのメッセージが表示された
 * メッセージボックスが存在するかを判定する。
 *
 * @method isShowing
 * @param msg メッセージボックスのメッセージ
 * @return 表示中のメッセージボックスが存在する場合true、しない場合false
 */
BlenderMessageBox.isShowing = function(msg) {
	var ret = false;

	if( msg ) {
		msg = msg.replace(/<br\/>/g,'').replace(/<BR\/>/g,'')
			.replace(/<br>/g,'').replace(/<BR>/g,'');
	}

	var tmp = $("#bodyPanel").find("#bl_MsgBoxDiv");
	if( tmp.length > 0 ) {
		if( tmp.css("display") == "none" ) return false;

		if( msg ) {
			tmp.each(function(idx, val){
				var _msg = $(this).find("#bl_MsgAreaDiv").text();
				//alert(msg+"\nvs\n"+_msg);
				if( msg == _msg ) {
					ret = true;
					return false;
				}
				return true;
			});
		}else {
			ret = true;
		}
	}
	return ret;
}

/**
 * メッセージボックス用の簡易ダイアログ
 */
function BlenderMessageBoxDialog(param) {
	this.title = param["title"] || null;
	this.type = param["type"] || BlenderMessageBox.MSG_TYPE_INFO;
	this.msgWidth = param["width"] || 400;
	this.msgHeight = param["height"] || 150;
	this.detailWidth = param["detailWidth"] || this.msgWidth;
	this.detailHeight = param["detailHeight"] || this.msgHeight+300;
	this.imagePath = param["imagePath"] || (BlenderMessageBox.imagePath || BlenderMessageBox._imagePath);
	this.wSkin = param["skin"] || "blender";
	this.i18n = BlenderCustomSettings.messageBoxDialogLangData;
	if( param["lang"] ) {
		this.lang = param["lang"];
	}else {
		for(var key in this.i18n) {
			this.lang = key;
			break;
		}
	}

	this.msgBoxDiv;

	this.icon;

	if( this.type == BlenderMessageBox.MSG_TYPE_INFO ) {
		this.title = (this.title ? this.title : this.i18n[this.lang].infoLabel);
		this.icon = this.imagePath + (this.imagePath.endsWith("/") ? "" : "/") + "icon-info-min.png";
	}else if( this.type == BlenderMessageBox.MSG_TYPE_WARN ) {
		this.title = (this.title ? this.title : this.i18n[this.lang].warnLabel);
		this.icon = this.imagePath + (this.imagePath.endsWith("/") ? "" : "/") + "icon-warning-min.png";
	}else if( this.type == BlenderMessageBox.MSG_TYPE_QUESTION ) {
		this.title = (this.title ? this.title : this.i18n[this.lang].questionLabel);
		this.icon = this.imagePath + (this.imagePath.endsWith("/") ? "" : "/") + "icon-question-min.png";
	}else if( this.type == BlenderMessageBox.MSG_TYPE_ERROR ) {
		this.title = (this.title ? this.title : this.i18n[this.lang].errorLabel);
		this.icon = this.imagePath + (this.imagePath.endsWith("/") ? "" : "/") + "icon-error-min.png";
	}
}

/**
 * メッセージボックス用の簡易ダイアログを初期化する。
 */
BlenderMessageBoxDialog.prototype.init = function() {

	var bodyPanel = $("#bodyPanel");

	var parentWidth = bodyPanel.width();
	var parentHeight = bodyPanel.height();

	var top = (parentHeight/2) - (this.msgHeight/2);
	var left = (parentWidth/2) - (this.msgWidth/2);

	var detailAreaTop = 20;

	var wBrdLeft = 1;
	var wBrdTop = 30;
	var wBrdWidthOffset = -14;
	var wBrdHeightOffset = -36;
	if(this.wSkin == "dhx_web"){
		wBrdTop = 28;
	}else
	if(this.wSkin == "material"){
		detailAreaTop = 10;
		wBrdLeft = 0;
		wBrdWidthOffset = -6;
		wBrdHeightOffset = -34;
	}
//	if("detailAreaTop" in param) detailAreaTop = param["detailAreaTop"];
//	if("wBrdLeft" in param) wBrdLeft = param["wBrdLeft"];
//	if("wBrdTop" in param) wBrdTop = param["wBrdTop"];
//	if("wBrdWidthOffset" in param) wBrdWidthOffset = param["wBrdWidthOffset"];
//	if("wBrdHeightOffset" in param) wBrdHeightOffset = param["wBrdHeightOffset"];

	this.msgBoxDiv = $("<div id='bl_MsgBoxDiv' class='dhxwins_vp_"+this.wSkin+"' style='top:"+top+"px;left:"+left+"px;width:"+this.msgWidth+"px;height:"+this.msgHeight+"px;z-index:10001'></div>");

	var btnsTag = $("<div class='dhtmlx_wins_btns'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>")
		.append("<div class='dhtmlx_wins_btns_button' style='display: none'></div>");

	var inner = $("<div class='dhx_cell_cont_wins' style='top:29px;left:7px;width:"+(this.msgWidth-16)+"px;height:"+(this.msgHeight-40)+"px'></div>");
//		.append(contBody)
//		.append(blocker);

	var title = $("<div class='dhxwin_text'><div class='dhxwin_text_inside' style='padding-right: 26px; padding-left: 30px;'>"+this.title+"</div></div>");
	var hdr = $("<div class='dhxwin_hdr'>")
		.append(title)
		.append("<div class='dhxwin_icon' style='background-image: url("+this.icon+")'></div></div>");
	var outer = $("<div id='handle' class='dhxwin_active' style='width:"+(this.msgWidth-2)+"px;height:"+(this.msgHeight-2)+"px;z-index:105;'></div>")
		.append("<iframe class='dhtmlx_wins_ie6_cover_fix' frameborder='0'></iframe>")
		.append("<div class='dhtmlx_wins_progress' style='display: none'></div>")
		.append(hdr)
		.append(btnsTag)
		.append("<div class='dhxwin_brd' style='left:"+wBrdLeft+"px;top:"+wBrdTop+"px;width:"+(this.msgWidth+wBrdWidthOffset)+"px;height:"+(this.msgHeight+wBrdHeightOffset)+"px'></div>")
		.append(inner);

	this.msgBoxDiv.append(outer);
	this.msgBoxDiv.click(function() {
		return false;
	});
	this.msgBoxDiv.keydown(function(e){
		if(e.which == 113) { //F2
			e.preventDefault();
			return false;
		}
	});

	if( blockBodyPanel ) {
		blockBodyPanel(true);
		$("#bodyPanel").find("#bodyPanel_block").addClass("dhxwins_mcover").css('z-index','105');
	}

	bodyPanel.append(this.msgBoxDiv);

	if( this.msgBoxDiv.draggable ) {
		this.msgBoxDiv.draggable({
			cursor: "move",
			handle: "#handle"
		});
	}

	//for( var i=(option.length-1); i>=0; i-- ) {
	//	if( option[i] ) {
	//		init(i, btns[i], msgBoxHolder);
	//	}
	//}

}

/**
 * メッセージボックス用の簡易ダイアログにメッセージを追加する。
 */
BlenderMessageBoxDialog.prototype.attachObject = function(obj) {
	var outer = this.msgBoxDiv.children(":eq(0)");
	var inner = outer.children(":eq(5)");

	var blocker = $("<div class='dhx_cell_wins' style='display: none'></div>");

	inner.append(obj).append(blocker);
}

/**
 * メッセージボックス用の簡易ダイアログのサイズ取得。
 */
BlenderMessageBoxDialog.prototype.getDimension = function() {
	return [ this.msgBoxDiv.width(), this.msgBoxDiv.height() ];
}

/**
 * メッセージボックス用の簡易ダイアログを閉じる。
 */
BlenderMessageBoxDialog.prototype.close = function() {
	this.msgBoxDiv.remove();

	if( blockBodyPanel ) {
		blockBodyPanel(false);
	}
}

/**
 * メッセージボックス用の簡易ダイアログを隠す。
 */
BlenderMessageBoxDialog.prototype.hide = function() {
	this.msgBoxDiv.css("display", "none");
}

/**
 * メッセージボックスを保持するためのホルダークラス。
 */
function BlenderMessageBoxHolder(msgBox, width, height, detailWidth, detailHeight) {
	this._msgBox = msgBox;
	this._width = width;
	this._height = height;
	this._detailWidth = detailWidth;
	this._detailHeight = detailHeight;
	this._showDetail = false;

	var self = this;

	this.hide = function(e) {
//		if( self._msgBox instanceof jQuery ) {
//			self._msgBox.css("display", "none");
//		}else {
//			self._msgBox.hide();
//		}
		self._msgBox.hide();
	}

	this.close = function(e) {
//		if( self._msgBox instanceof jQuery ) {
//			self._msgBox.remove();
//		}else {
//			self._msgBox.close();
//		}
		self._msgBox.close();
	}

	this.showDetail = function(e) {
		if( self._showDetail ) {
			BlenderMessageBox.setSize(self._msgBox, self._width, self._height, false);
			$(e.target).val(self._msgBox.i18n[self._msgBox.lang].detailShowBtnLabel);
			self._showDetail = false;
		}else {
			BlenderMessageBox.setSize(self._msgBox, self._detailWidth, self._detailHeight, true);
			$(e.target).val(self._msgBox.i18n[self._msgBox.lang].detailHiddenBtnLabel);
			self._showDetail = true;
		}
	}

	this.copyDetail = function(e) {
		var detailArea;
		if( self._msgBox instanceof BlenderMessageBoxDialog ) {
			detailArea = self._msgBox.msgBoxDiv.find("#bl_DetailAreaDiv");
		}else {
			detailArea = $(self._msgBox.cell.childNodes[msgBox.conf.idx.cont]).find("#bl_DetailAreaDiv");
		}

		var detailMsgArea = detailArea.children(":eq(1)");

		var text = detailMsgArea.html().replace(/<BR>/g,'\r\n').replace(/<br>/g,'\r\n');
		if (window.clipboardData) {
			window.clipboardData.setData("Text",text);
		}else {
			(new Clipboard()).copy(text);
		}
	}
}

/**
 * メッセージボックスボタンを制御するためのホルダークラス。
 */
function BlenderMessageBoxKeyHolder(leftBtn,rightBtn) {
	var _leftBtn = leftBtn;
	var _rightBtn = rightBtn;

	this.keyup = function(e) {
		if(e.which==37) {
			// left key
			if( _leftBtn ) {
				_leftBtn.focus();
			}
		}else if(e.which==39) {
			// right key
			if( _rightBtn ) {
				_rightBtn.focus();
			}
		}
	}
}

//---------------------------------------
// 入力ボックス
//---------------------------------------

/** オプションラベル */
BlenderPromptBox.OPTION_LABEL = { ok: "okBtnLabel", cancel: "cancelBtnLabel" };

/** デフォルトエラーメッセージ */
BlenderPromptBox.DEFAULT_ERROR_MSG = "defaultErrMsg";
/** TabIndex のオフセット */
BlenderPromptBox.TAB_INDEX_OFFSET = 1000;

/** 精査処理テーブル */
BlenderPromptBox._validLogic = {
	required: "checkRequired",
	mask: "checkMask",
	maxLength: "checkMaxLength",
	maxBytes: "checkMaxBytes",
	maxMultiBytes: "checkMaxMultiBytes",
	fitLength: "checkFitLength",
	integer: "checkInteger",
	intRange: "checkIntRange",
	double: "checkDouble",
	floatRange: "checkFloatRange"
};

/** 入力ボックス */
BlenderPromptBox._promptBox = null;
/** イメージパス */
BlenderPromptBox._imagePath = null;

/**
 * 入力ボックス
 *
 * @module BlenderComponent
 * @class BlenderPromptBox
 */
function BlenderPromptBox() {}

/**
 * 入力ボックスを表示する。
 *
 * 入力ボックスは互換性のため BlenderMessageBox.isShowing() で表示有無の判定を行うことができます。
 *
 * @method show
 * @param {object} param 入力ボックスパラメータ（以下のキーを持つ連想配列）
 *				"title": タイトル
 *				"msg": メッセージ本文
 *				"msgParam": メッセージ本文パラメータ
 *				"width": ダイアログ幅
 *				"height": ダイアログ高
 *				"value": 入力値
 *				"placeholder": テキストボックスが空の時に表示する文字列
 *				"ok": OK選択時のコールバック関数
 *				　　関数実行時の引数は以下の通り
 *				　　　　event: 選択時のイベントオブジェクト
 *				　　　　text: テキストボックスの入力内容
 *				"cancel": キャンセル選択時のコールバック。関数の引数はokと同一。
 *				"validRules": 入力内容の精査ルールオブジェクト配列
 *				　　以下のキーを持つ連想配列
 *				　　　　"name": 精査ルール名（required/mask/maxLength/maxBytes/maxMultiBytes/fitLength/integer/intRange/double/floatRange）
 *				　　　　"param": 精査のパラメータ
 *				　　　　"msg": カスタムエラーメッセージ。未指定の場合 BlenderPromptBox.DEFAULT_ERROR_MSGを表示する。
 *				　　　　例）
 *				　　　　　　[
 *				　　　　　　　　{ name: "required" },
 *				　　　　　　　　{ name: "maxLength", param: 10, msg: "10字以下にしてください。" }
 *				　　　　　　]
 *				"skin": スキン設定（既定値: blender）
 *				"lang": ボタンに表示する言語(デフォルト,jp:日本語)
 */
BlenderPromptBox.show = function(param) {
	var promptBox = BlenderPromptBox.createDialog(param);

	BlenderPromptBox.buildContent(promptBox, param);
	BlenderPromptBox._promptBox = promptBox;
};

/**
 * 入力ボックスのウィンドウ枠を生成する。
 *
 * @method createDialog
 * @param param {object} 入力ボックスパラメータ（項目はshow関数参照）
 * @return {BlenderPromptBoxDialog} 入力ボックスのウィンドウ枠
 */
BlenderPromptBox.createDialog = function(param) {
	"use strict";

	var promptBox = new BlenderPromptBoxDialog(param);
	promptBox.init();

	return promptBox;
};

/**
 * 指定された入力ボックスのコンテンツを生成する。
 *
 * @method buildContent
 * @param promptBox {BlenderPromptBoxDialog} 入力ボックス
 * @param param {object} 入力ボックスパラメータ（項目はshow関数参照）
 */
BlenderPromptBox.buildContent = function(promptBox, param) {
	"use strict";

	var msg = param.msg || "",
		msgParam = param.msgParam || [],
		value = param.value || "",
		placeholder = param.placeholder || "",
		validRules = (param.validRules && param.validRules.length) ? BlenderUtil.clone(param.validRules, true) : null,
		skin = param.skin || "blender",
		tabIdxOffset = BlenderPromptBox.TAB_INDEX_OFFSET;

	msg = BlenderUtil.createMessage(msg, msgParam);

	var promptBoxHolder = new BlenderMessageBoxHolder(promptBox, promptBox.msgWidth, promptBox.msgHeight);

	// メッセージ表示領域
	var $msgDiv = $("<div />")
			.attr("id", "bl_MsgAreaDiv")
			.addClass("blender-prompt-box")
			.html(msg);

	// エラーメッセージ表示領域
	var $errMsgDiv = $("<div />")
			.attr("id", "bl_PromptErrMsgDiv")
			.text(" ");

	// テキスト入力
	var $inputText = $("<input />", {
		attr: {
			id: "bl_PromptInputText",
			type: "text",
			tabindex: tabIdxOffset,
			placeholder: placeholder
		},
		val: value,
		on: {
			input: function(e) {
				$errMsgDiv.empty();
			}
		}
	});

	// バリデート処理
	var validation = BlenderPromptBox._createValidation(promptBox, validRules, $inputText, $errMsgDiv);

	// OKボタン
	var $btnOk = BlenderPromptBox._buildControlButton("ok", tabIdxOffset + 1, validation, $inputText,
			param.ok, promptBox, promptBoxHolder);
	// キャンセルボタン
	var $btnCancel = BlenderPromptBox._buildControlButton("cancel", tabIdxOffset + 2, null, $inputText,
			param.cancel, promptBox, promptBoxHolder);

	var keyHolder = new BlenderMessageBoxKeyHolder($btnOk, $btnCancel);

	$btnOk.on("keyup", keyHolder.keyup);
	$btnCancel.on("keyup", keyHolder.keyup);

	var $contentBody = $("<div />")
			.attr("id", "dhxmaincont")
			.addClass("blender-prompt-box " + skin)
			.append([
				$msgDiv,
				$errMsgDiv,
				$inputText,
				$btnOk,
				$btnCancel
			]);

	setTimeout(function() {
		$inputText.focus();
	});

	promptBox.attachObject($contentBody[0]);
};

/**
 * 入力ボックスのイメージパスを設定する。
 * nullを設定した場合, メッセージボックスのイメージパス設定を使用する。
 *
 * @method setImagePath イメージパス(相対)
 * @param path {string} イメージパス
 */
BlenderPromptBox.setImagePath = function(path) {
	BlenderPromptBox._imagePath = path;
}

/**
 * 表示中のメッセージボックスが存在するか判定する。
 * BlenderMessageBox.isShowing と同一の結果を返す。
 *
 * @method isShowing
 * @param msg {string} メッセージボックスのメッセージ
 * @return {boolean} 表示中のメッセージボックスが存在する場合true、しない場合false
 */
BlenderPromptBox.isShowing = function(msg) {
	return BlenderMessageBox.isShowing(msg);
};

/**
 * 入力ボックスの操作ボタンを作成する。
 *
 * @private
 * @method _buildControlButton
 * @param name {string} ボタンのname属性値
 * @param tabindex {number} タブインデックス
 * @param validation {Function} 精査処理
 * @param $inputText {JQuery} 文字入力
 * @param clickHandler {Function} ボタンクリック時の処理
 * @param promptBox {BlenderPromptBoxDialog} 入力ボックスダイアログ
 * @param promptBoxHolder {BlenderMessageBoxHolder} 入力ボックスを制御するためのホルダーオブジェクト
 * @return 作成したボタンのJQueryオブジェクト
 */
BlenderPromptBox._buildControlButton = function(name, tabindex, validation, $inputText,
		clickHandler, promptBox, promptBoxHolder) {
	"use strict";

	var btnVal = BlenderPromptBox.OPTION_LABEL[name];
	btnVal = promptBox.i18n[promptBox.lang][btnVal];

	var $button = $("<input />", {
		attr: {
			type: "button",
			name: name,
			tabindex: tabindex
		},
		val: btnVal,
		addClass: "blender-button"
	});

	// 精査処理設定
	if (validation) {
		$button.on("click", validation);
	}

	if (clickHandler) {
		// コールバック実行前に非表示にする。
		$button.on("click", promptBoxHolder.hide);

		// ボタンクリック コールバック処理設定
		$button.on("click", function(e) {
			return clickHandler.call(this, e, $inputText.val());
		});
	}

	// 閉じる設定
	$button.on("click", promptBoxHolder.close);

	return $button;
};

/**
 * 入力ボックスのバリデーション処理を作成する。
 *
 * @private
 * @method _createValidation
 * @param promptBox {BlenderPromptBoxDialog} 入力ボックスダイアログ
 * @param validRules {Array} 精査ルール配列
 * @param $inputText {JQuery} テキストボックスのJQueryオブジェクト
 * @param $errMsgDiv {JQuery} エラーメッセージ表示域のJQueryオブジェクト
 */
BlenderPromptBox._createValidation = function(promptBox, validRules, $inputText, $errMsgDiv) {
	"use strict";
	if (!validRules) {
		return null;
	}
	return function(e) {
		var ret, vRule, vLogicNm, vArgs,
			value = [$inputText.val()];

		for (var i = 0, ilen = validRules.length; (!ret && i < ilen); i++) {
			vRule = validRules[i];
			vLogicNm = BlenderPromptBox._validLogic[vRule.name];
			vArgs = value;

			if ("param" in vRule) {
				vArgs = vArgs.concat(vRule.param);
			}
			ret = BlenderValidator[vLogicNm].apply(null, vArgs);
		}
		if (ret) {
			$errMsgDiv.text(vRule.msg || promptBox.i18n[promptBox.lang][BlenderPromptBox.DEFAULT_ERROR_MSG]);
			e.stopImmediatePropagation();
		}
		return !ret;
	}
};

/**
 * 入力ボックス用のダイアログ
 *
 * @class BlenderPromptBoxDialog
 * @extends BlenderMessageBoxDialog
 * @constructor
 * @param param {object} ダイアログパラメータ
 */
function BlenderPromptBoxDialog(param) {
	BlenderMessageBoxDialog.apply(this, arguments);

	if (!param.title) {
		this.title = "";
	}
	if (!param.height) {
		this.msgHeight += 15;
	}
	this.imagePath = BlenderPromptBox._imagePath || this.imagePath;
	this.icon = this.imagePath + (this.imagePath.endsWith("/") ? "" : "/") + "icon-prompt-min.png";

	this.i18n = BlenderCustomSettings.promptBoxDialogLangData;

	if (!param.lang) {
		for (var key in this.i18n) {
			this.lang = key;
			break;
		}
	}
}

// メッセージボックスダイアログを継承
BlenderPromptBoxDialog.inherit(BlenderMessageBoxDialog);


//---------------------------------------
// フロートメッセージ
//---------------------------------------

/** フロートメッセージイメージパス **/
BlenderFloatMessage.imagePath = "codebase/blender/imgs";

/**
 * フロートメッセージ
 *
 * @module BlenderComponent
 * @class BlenderFloatMessage
 * @param id フロートメッセージ用のタグID。このIDでタグを生成する。
 */
function BlenderFloatMessage(id) {

	this.tagId = (id ? id : "floatMsg");
	this.floatMsg = null;

}

/**
 * フロートメッセージのイメージパスを設定する。
 *
 * @method setImagePath イメージパス(相対)
 * @param path イメージパス
 */
BlenderFloatMessage.setImagePath = function(path) {
	BlenderFloatMessage.imagePath = path;
}

/**
 * 初期化する。
 *
 * @method init
 */
BlenderFloatMessage.prototype.init = function() {

	var icon = BlenderFloatMessage.imagePath + (BlenderFloatMessage.imagePath.endsWith("/") ? "" : "/") + "float-msg-close.gif";

	this.floatMsg = $("<div id='"+this.tagId+"' class='blender-float-message'/>");
	this.floatMsg.attr("style", "display:none");

	this.floatMsg.append("<span class='span1'></span>");
	this.floatMsg.append("<span class='span2'><img src='"+icon+"' width='13' height='13'/></span>");

	$("body").prepend(this.floatMsg);

	var self = this;

	$("#"+this.tagId+" > span:eq(1) > img").click(function(){
		self.hide();
	});

}

/**
 * メッセージを表示する。
 *
 * @method show
 * @param msg メッセージ
 */
BlenderFloatMessage.prototype.show = function(msg) {

	$("#"+this.tagId+" > span:first").html(msg);

	$("#"+this.tagId).css("display", "block");
	$("#sysMenu").css("top", "20px");
	$("#windowArea").css("top", "48px");

}

/**
 * メッセージを隠す。
 *
 * @method hide
 */
BlenderFloatMessage.prototype.hide = function() {

	$("#"+this.tagId).css("display", "none");
	$("#sysMenu").css("top", "0px");
	$("#windowArea").css("top", "28px");

}

//---------------------------------------
// メッセージ定義
//---------------------------------------

MessageConstants.MSG_C0000 = "想定外のエラーが発生しました。";
MessageConstants.MSG_C0001 = "サーバへの処理要求に失敗しました。<br/>status: {0}, errorThrown: {1}";
MessageConstants.MSG_C0002 = "ログアウトしますか？";
MessageConstants.MSG_C0003 = "アプリケーションを終了しますか？";
MessageConstants.MSG_C0004 = "処理中です";
MessageConstants.MSG_C0005 = "処理中状態の確認が実施できませんでした。";
MessageConstants.MSG_C0006 = "メニューから開ける画面(親画面)は{0}画面までです。<br/>操作不要な画面(親画面)を閉じてください。";

MessageConstants.MSG_C1000 = "不正な入力データがあります。";
MessageConstants.MSG_C1001 = "編集中のデータがあります。<br/>データを破棄しますか？";
MessageConstants.MSG_C1002 = "対象データが見つかりません。";
MessageConstants.MSG_C1003 = "編集中のデータがあります。<br/>システムにデータを反映してください。";

MessageConstants.MSG_C2000 = "処理対象が選択されていません。";
MessageConstants.MSG_C2001 = "１行選択してください。";
MessageConstants.MSG_C2002 = "１列選択してください。";
MessageConstants.MSG_C2003 = "登録データが存在しません。";
MessageConstants.MSG_C2004 = "データを登録しますか？";
MessageConstants.MSG_C2005 = "削除が含まれていますが、データを登録しますか？";
MessageConstants.MSG_C2006 = "登録が完了しました。";
MessageConstants.MSG_C2007 = "登録に失敗しました。";
MessageConstants.MSG_C2008 = "データを削除しますか？";
MessageConstants.MSG_C2009 = "削除が完了しました。";
MessageConstants.MSG_C2010 = "削除に失敗しました。";
MessageConstants.MSG_C2011 = "データを確定しますか？";
MessageConstants.MSG_C2012 = "確定が完了しました。";
MessageConstants.MSG_C2013 = "確定に失敗しました。";
MessageConstants.MSG_C2014 = "警告がありますが、強制登録しますか？";
MessageConstants.MSG_C2015 = "処理に失敗しました。";
MessageConstants.MSG_C2016 = "制御を実行しますか？";
MessageConstants.MSG_C2020 = "本画面はダウンロード対象外です。";
MessageConstants.MSG_C2021 = "データをダウンロードしますか？";
MessageConstants.MSG_C2022 = "ダウンロード条件が確定されていません。";
MessageConstants.MSG_C2030 = "必須項目が未入力です。";

function MessageConstants() {
}

//---------------------------------------
// Validator
//---------------------------------------

/**
 * 入力チェック精査クラス。
 *
 * @module blendercommon
 * @class BlenderValidator
 */
function BlenderValidator() {
}

/**
 * 必須チェックを実施する。
 *
 * @method checkRequired
 * @param value 値
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkRequired = function(value) {
	var ret = false;
	if( isEmpty(value) ) {
		ret = true;
	}
	return ret;
}

/**
 * 正規表現チェックを実施する。
 *
 * @method checkMask
 * @param value 値
 * @param mask チェック用正規表現
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkMask = function(value,mask) {
	var ret = false;

	if( !isEmpty(value) ) {
		if( !value.toString().match(mask) ) {
			ret = true;
		}
	}
	return ret;
}

/**
 * 最大文字数チェックを実施する。
 *
 * @method checkMaxLength
 * @param value 値
 * @param maxLength 最大文字数
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkMaxLength = function(value,maxLength) {
	var ret = false;

	if( !isEmpty(value) ) {
		var count = value.toString().length;
		if (count > maxLength) {
			//入力された文字数が最大文字数より長い場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 最大バイト数チェックを実施する。
 *
 * @method checkMaxBytes
 * @param value 値
 * @param maxBytes 最大バイト数
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkMaxBytes = function(value,maxBytes) {
	var ret = false;

	if( !isEmpty(value) ) {
		var count = 0;
		value = value.toString();
		//入力文字数を一文字ずつチェック
		for( var i=0; i<value.length; ++i ) {
			//一文字ずつ取り出す
			var sub = value.substring(i, i+1);
			//全角半角チェック
			if( BlenderUtil.isTwoByteCharCode(sub) ){
				//全角の場合
				count += 2;
			} else {
				//半角の場合
				count += 1;
			}
		}
		if (count > maxBytes) {
			//入力された文字列のバイト数が最大バイト数より長い場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 最大バイト数チェックを実施する。
 *
 * @method checkMaxMultiBytes
 * @param value 値
 * @param maxBytes 最大バイト数
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkMaxMultiBytes = function(value,maxBytes) {
	var ret = false;

	if( !isEmpty(value) ) {
		var count = 0;
		value = value.toString();
		//入力文字数を一文字ずつチェック
		for( var i=0; i<value.length; ++i ) {
			//一文字ずつ取り出す
			var sub = value.substring(i, i+1);
			count += BlenderUtil.lengthMultiBytes(sub);
		}
		if (count > maxBytes) {
			//入力された文字列のバイト数が最大バイト数より長い場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 整数範囲チェック(最小値以上、最大値以下)を実施する。
 *
 * @method checkIntRange
 * @param value 値
 * @param min 最小値
 * @param max 最大値
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkIntRange = function(value,min,max) {
	var ret = false;

	if( !isEmpty(value) ) {
		var target = (isNumber(value) ? value : parseInt(value));

		if (target < min || max < target ) {
			//入力された値が範囲外の場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 実数範囲チェック(最小値以上、最大値以下)を実施する。
 *
 * @method checkFloatRange
 * @param value 値
 * @param min 最小値
 * @param max 最大値
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkFloatRange = function(value,min,max) {
	var ret = false;

	if( !isEmpty(value) ) {
		var target = (isNumber(value) ? value : Number(value));

		if (target < min || max < target ) {
			//入力された値が範囲外の場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 実数範囲チェック(開始日～終了日以内)を実施する。
 *
 * @method checkDateRange
 * @param value 値
 * @param from 開始日
 * @param to 終了日
 * @param dateformat 日付フォーマット(ex. "%Y/%m/%d")
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkDateRange = function(value,from,to,dateformat) {
	var ret = false;

	if( !isEmpty(value) ) {
		var targetDate = BlenderDateUtil.parseDate(value, dateformat);
		var fromDate   = BlenderDateUtil.parseDate(from,  dateformat);
		var toDate     = BlenderDateUtil.parseDate(to,    dateformat);

		if (targetDate < fromDate || toDate < targetDate ) {
			//入力された値が範囲外の場合エラー
			ret = true;
		}
	}
	return ret;
}

/**
 * 日付正規チェックを実施する。
 *
 * @method checkDate
 * @param value 値(日付文字列)
 * @param dateformat 日付フォーマット(ex. "%Y/%m/%d")
 * @return 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkDate = function(value,dateformat) {
	var ret = false;

	if( !isEmpty(value) ) {
		var parseDate = BlenderDateUtil.parseDate(value, dateformat);
		var parseDateStr = BlenderDateUtil.formatDate(parseDate, dateformat);

		//alert("value: "+value+" vs "+parseDateStr);
		if ( value != parseDateStr ) {
			//入力された値が変わっていた場合エラー
			ret = true;
		}
	}

	return ret;
}

/**
 * 固定文字数チェックを実施する
 *
 * @method checkFitLength
 * @param value {string} 値
 * @param length {number} 文字数
 * @return {boolean} 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkFitLength = function(value, length) {
	return !isEmpty(value) && length !== value.toString().length;
}

/**
 * 整数正規チェックを実施する
 *
 * @method checkInteger
 * @param value {string} 値
 * @param digits {number} 数値の桁数。未指定または0以下の場合は桁数チェックを実施しない。
 * @return {boolean} 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkInteger = function(value, digits) {
	var ret = false;

	if (!isEmpty(value)) {
		ret = (0 < digits) ? ("{0," + (digits - 1) + "}") : "*";
		ret = !value.toString().match("^[+-]?(?:0|[1-9]\\d" + ret + ")$");
	}
	return ret;
}

/**
 * 実数正規チェックを実施する
 *
 * @method checkDouble
 * @param value {string} 値
 * @param precision {number} 精度（全体の最大桁数）
 * @param scale {number} スケール（小数点以下の最大桁数）
 * @return {boolean} 精査判定に問題があった場合true、問題ない場合false
 */
BlenderValidator.checkDouble = function(value, precision, scale) {
	var tmp;
	if (!(0 < precision && 0 <= scale && 0 <= (tmp = precision - scale))) {
		throw new Error("精度は正の整数、スケールは0～精度の整数を指定してください。");
	}
	var ret = false;

	if (!isEmpty(value)) {
		switch (tmp) {
		case 0:
			tmp = "0";
			break;
		case 1:
			tmp = "\\d";
			break;
		default:
			tmp = "(?:0|[1-9]\\d{0," + (--tmp) + "})";
			break;
		}
		ret = !value.toString().match("^[+-]?" + tmp + "(?:\\.\\d{1," + scale + "})?$");
	}
	return ret;
};

//---------------------------------------
//BLEnDerユーザー入力設定
//---------------------------------------
//
//設定を追加する場合は下記のとおり設定ください。
//・グループ名を追加する。
//	BlenderUserInput.addKeyDownRuleGroup("sampleGroup");
//・ルールを追加する。
//	BlenderUserInput.addKeyDownRules("sampleGroup",
//		[
//		 	[ 13, false, false, true, BlenderUserInput.PROCESS_KEY_DEFAULT ],
//		 	[ 122, false, false, false, BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_COMPONENT0 ]
//		 ]);
//・グループを有効化する。
//	BlenderUserInput.addEnableKeyDownGroups([ "sampleGroup" ]);
function BlenderUserInput() {
}

//各業務にて処理キーを追加する場合は9000～9999を使用ください。
/** ユーザー入力時の処理キー:デフォルト */
BlenderUserInput.PROCESS_KEY_DEFAULT = 1000;
/** ユーザー入力時の処理キー:編集可能部品の場合は無視する処理 */
BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_COMPONENT = 1001;
/** ユーザー入力時の処理キー:編集可能なtextareaの場合は無視する処理 */
BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_TEXTAREA = 1002;


/** ユーザー入力時の処理のキーと処理内容のMAP */
BlenderUserInput._processMap = {};

/** keydown時のルールを有効とするグループ名 */
BlenderUserInput._enableKeyDownGroups = ["backspace"];

/** mouseWheel時のルールを有効とするグループ名 */
BlenderUserInput._enableMouseWheelGroups = [];

/**
 * ドキュメント要素にユーザー入力無効化処理を設定する。
 * これにより設定されたエリア以外から
 * 発生されるキーイベントを抑制し、処理を実施させないように
 * することができる。
 */
BlenderUserInput.setupDisableUserInput = function() {

	$(document).keydown(function (e) {
		for (var groupName in BlenderUserInput._keyDownRuleMap) {
			if (0 <= $.inArray(groupName, BlenderUserInput._enableKeyDownGroups)) {
				var rules = BlenderUserInput._keyDownRuleMap[groupName];
				for ( var i = 0; i < rules.length; i++) {
					var rule = rules[i];
					if (rule[0] === e.which  && rule[1] === e.shiftKey && rule[2] === e.ctrlKey
							&& rule[3] === e.altKey) {
						return BlenderUserInput._processMap[rule[4]](e);
					}
				}
			}
		}
	});

	var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
	$(document).on(mousewheelevent, function(e) {
		for ( var groupName in BlenderUserInput._mouseWheelRuleMap) {
			if (0 <= $.inArray(groupName, BlenderUserInput._enableMouseWheelGroups)) {
				var rules = BlenderUserInput._mouseWheelRuleMap[groupName];
				for ( var i = 0; i < rules.length; i++) {
					var rule = rules[i];
					if (rule[0] === e.shiftKey && rule[1] === e.ctrlKey
							&& rule[2] === e.altKey) {
						return BlenderUserInput._processMap[rule[3]](e);
					}
				}
			}
		}
	});

};

/**
 * 編集可能な入力部品か
 * @param target 対象の部品
 * @returns 編集可能な入力部品の場合はtrue それ以外はfalse
 */
BlenderUserInput._editableInputComponent = function(target) {
	return (target.type == "text" || target.type == "password" || target.type == "textarea")
			&& target.readOnly == false;
};

/**
 * 編集可能なtextareaか
 * @param target 対象のtextarea
 * @returns 編集可能なtextareaの場合はtrue それ以外はfalse
 */
BlenderUserInput._editableTextArea = function(target) {
	return target.type == "textarea" && target.readOnly == false;
};

/**
 * ユーザー入力を無効化する処理
 * @param e jQueryイベント
 * @returns false
 */
BlenderUserInput._defaultProcess = function(e) {
	return false;
};

/**
 * 編集可能な入力部品の場合は無視する処理
 * @param e jQueryイベント
 * @returns 編集可能な入力部品以外の場合はfalse
 */
BlenderUserInput._ignoreEditableInputComponentProcess = function(e) {
	if(!BlenderUserInput._editableInputComponent(e.target)){
		return false;
	}
};

/**
 * 編集可能なtextareaの場合は無視する処理
 * @param e jQueryイベント
 * @returns 編集可能なtextarea以外の場合はfalse
 */
BlenderUserInput._ignoreEditableTextareaProcess = function(e) {
	if(!BlenderUserInput._editableTextArea(e.target)){
		return false;
	}
};

// 処理の定義後にMAPに追加する。
BlenderUserInput._processMap[BlenderUserInput.PROCESS_KEY_DEFAULT] = BlenderUserInput._defaultProcess;
BlenderUserInput._processMap[BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_COMPONENT] = BlenderUserInput._ignoreEditableInputComponentProcess;
BlenderUserInput._processMap[BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_TEXTAREA] = BlenderUserInput._ignoreEditableTextareaProcess;

/**
 * keyDown時の処理を追加する。
 * @param key 処理キー
 * @param process 処理関数
 */
BlenderUserInput.addKeyDownProcess = function(key, process) {
	BlenderUserInput._processMap[key] = process;
};

/**
 * keyDown時のルール
 * 書式は下記のとおり
 * {
 * 	"グループ名":
 * 		[
 * 			[キーコード, Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー],
 * 			・・・
 * 		],
 * 		・・・
 * }
 */
BlenderUserInput._keyDownRuleMap = {
	"backspace" : [
		[ 8, false, false, false, BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_COMPONENT ]	// Backspace
	],
	"focus": [
		[ 69, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	// E
		[ 76, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	// L
		[ 117, false, false, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	// F6
	],
	"pageMove" : [
		[ 37, false, false, true, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//左
		[ 39, false, false, true, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//右
	],
	"pageClose" : [
		[ 87, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//W
	],
	"pageReload" : [
		[ 82, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//R
		[ 116, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//F5
	],
	"explorerBar" : [
	 	[ 71, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//G
	 	[ 72, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//H
	 	[ 73, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//I
	],
	"newPage":[
		[ 75, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//K
		[ 78, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ],	//N
		[ 84, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//T
	],
	"submit":[
		[ 13, false, false, false, BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_TEXTAREA ]	//Enter
	],
	"cursorBrowse":[
		[ 118, false, false, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//F7
	],
	"developmentTools":[
	 	[ 123, false, false, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//F12
	],
	"downloadManager":[
		 [ 74, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//J
	],
	"pageSave" : [
		[ 83, false, true, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]	//S
	],
	"contextMenu":[
		 [ 121, true, false, false, BlenderUserInput.PROCESS_KEY_IGNORE_EDITABLE_COMPONENT ]	//F10
	]
};

/**
 * mouseWheel時のルール
 * 書式は下記のとおり
 * {
 * 	"グループ名":
 * 		[
 * 			[Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー],
 * 			・・・
 * 		],
 * 		・・・
 * }
 */
BlenderUserInput._mouseWheelRuleMap = {
	"pageMove" : [
		[ true, false, false, BlenderUserInput.PROCESS_KEY_DEFAULT ]
	]
};

/**
 * keydown時のルールのグループ名を追加する。
 * @param groupName 追加するグループ名
 */
BlenderUserInput.addKeyDownRuleGroup = function(groupName){
	BlenderUserInput._keyDownRuleMap[groupName] = [];
};

/**
 * mouseWheel時のルールのグループ名を追加する。
 * @param groupName 追加するグループ名
 */
BlenderUserInput.addMouseWheelRuleGroup = function(groupName){
	BlenderUserInput._mouseWheelRuleMap[groupName] = [];
};

/**
 * keydown時のルールを追加する。
 * @param groupName グループ名
 * @param rule ルール 書式は下記のとおり
 * 	[キーコード, Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー]
 */
BlenderUserInput.addKeyDownRule = function(groupName, rule){
	BlenderUserInput.addKeyDownRules(groupName, [rule]);
};

/**
 * keydown時のルールを追加する。
 * @param groupName グループ名
 * @param rules ルールの配列 書式は下記のとおり
 * 	[
 * 		[キーコード, Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー],
 * 		・・・
 * 	]
 */
BlenderUserInput.addKeyDownRules = function(groupName, rules){
	for ( var i = 0; i < rules.length; i++) {
		BlenderUserInput._keyDownRuleMap[groupName].push(rules[i]);
	}
};

/**
 * mouseWheel時のルールを追加する。
 * @param groupName グループ名
 * @param rule ルール 書式は下記のとおり
 * 	[Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー]
 */
BlenderUserInput.addMouseWheelRule = function(groupName, rule){
	BlenderUserInput.addMouseWheelRules(groupName, [rule]);
};

/**
 * mouseWheel時のルールを追加する。
 * @param groupName グループ名
 * @param rules ルールの配列 書式は下記のとおり
 * 	[
 * 		[キーコード, Shift押下有無, Ctrl押下有無, Alt押下有無, 処理キー],
 * 		・・・
 * 	]
 */
BlenderUserInput.addMouseWheelRules = function(groupName, rules){
	for ( var i = 0; i < rules.length; i++) {
		BlenderUserInput._mouseWheelRuleMap[groupName].push(rules[i]);
	}
};

/**
 * keydown時のルールを有効とするグループ名を追加する。
 * @param groupNames グループ名の配列
 */
BlenderUserInput.addEnableKeyDownGroups = function(groupNames){
	for ( var i = 0; i < groupNames.length; i++) {
		BlenderUserInput._enableKeyDownGroups.push(groupNames[i]);
	}
};

/**
 * mouseWheel時のルールを有効とするグループ名を追加する。
 * @param groupNames グループ名の配列
 */
BlenderUserInput.addEnableMouseWheelGroups = function(groupNames){
	for ( var i = 0; i < groupNames.length; i++) {
		BlenderUserInput._enableMouseWheelGroups.push(groupNames[i]);
	}
};

//---------------------------------------
// カレンダー設定
// (blendercalendar.js、blendergrid_excell_bl_calendar.js共通の定義)
//---------------------------------------
/**
 * 日付の下限
 * ・dhtmlxCalendar.setSensitiveRange()で設定する。
 * ・範囲外の日付は選択不可となる。（カレンダー自体は範囲外の年月でも表示 */
BlenderCalendarSettings.FROM_DATE = "1900/01/01";

/**
 * 日付の上限
 * ・dhtmlxCalendar.setSensitiveRange()で設定する。
 * ・範囲外の日付は選択不可となる。（カレンダー自体は範囲外の年月でも表示  */
BlenderCalendarSettings.TO_DATE = "2099/12/31";

/**
 * 日付項目の整形処理制御(不正値を保持する)<br>
 * ・本フラグをtrueに設定すると、不正値を入力した際に正常値への自動補正を行わない。
 */
BlenderCalendarSettings.KEEP_INVALID_DATE = true;

/**
 * 日付項目の整形処理制御(開始終了期間の逆転を保持する)<br>
 * ・本フラグをtrueに設定すると、開始終了日付の前後関係が逆転するような値を
 *   入力した場合でも、自動補正を行わない。
 */
BlenderCalendarSettings.KEEP_INVERSE_RANGE = true;


function BlenderCalendarSettings() {
}

//---------------------------------------
// BlenderGrid設定
//---------------------------------------

/**
 * コピー時の既定動作をテキストのみに設定
 */
BlenderGridSettings.FORCE_LABEL_SELECTION = false;

function BlenderGridSettings() {
}

//---------------------------------------
// BlenderWindowManager設定
//---------------------------------------

/**
 * ユーティリティメニューでウィンドウを切り替える際、子ウィンドウが開いていれば維持する設定
 */
BlenderWinManSettings.KEEP_CHILD_WINDOWS = false;

/**
 * 前面表示する際に親ウィンドウとセットで前面表示する設定
 */
BlenderWinManSettings.ACTIVATE_LINEALLY = false;

function BlenderWinManSettings() {
}

//---------------------------------------
// BLEnDer基本設定
//---------------------------------------

// BlenderMessageBoxで利用する画像ファイルの定義
BlenderMessageBox.setImagePath("../webjars/codebase/blender/imgs/");

//BlenderPromptBoxで利用する画像ファイルの定義
BlenderPromptBox.setImagePath("../webjars/codebase/blender/imgs/");

// BlenderFloatMessageで利用する画像ファイルの定義
BlenderFloatMessage.setImagePath(BlenderFloatMessage.imagePath.replace(/\/codebase\//g, "/webjars/codebase/"));

//---------------------------------------
// Other 以下未整理
//---------------------------------------

// カンレンダー日付入力フィールド編集ハンドラ
function CalendarEditHandler(calendarObj, required){
	this.calendarObj = calendarObj;
	this.required = required;
	this.onFocus = function(e) {
		var tmp = $(this).val();
		$(this).val( tmp.replace(/\//g,"") );
		$(this).select();
	};
	this.onBlur = function(e) {
		var findErr = false;
		var date = null;

		var tmp = $(this).val();
		if( tmp ) {
			if( tmp.match(/^\d{8}$/) ) {
				var yyyy = eval(tmp.substring(0,4));
				var mm = eval(tmp.substring(4,6));
				var dd = eval(tmp.substring(6,8));
				var tmpDate = new Date(yyyy, mm-1, dd);

				if( tmpDate.getFullYear()==yyyy
				 && (tmpDate.getMonth()+1)==mm
				 && tmpDate.getDate()==dd ) {
					date = tmpDate;
				}else {
					findErr = true;
				}
			}else {
				findErr = true;
			}
		}else {
			if( required ) findErr = true;
		}

		if( !findErr ) {
			if( date ) {
				calendarObj.setDate(date);
				$(this).val( calendarObj.getFormatedDate(null, date) );
			}
			return true;
		}else {
			if( required ) {
				$(this).val( calendarObj.getFormatedDate(null, calendarObj.date) );
			}else {
				$(this).val( "" );
			}
			return false;
		}
	};
}

// セル値が#cspanの場合、左セルと列結合を実施する
function setupColSpan(grid,startRowIndex, endRowIndex) {
	if( startRowIndex==undefined ) {
		startRowIndex = 0;
	}
	if( endRowIndex==undefined ) {
		endRowIndex = grid.getRowsNum()-1;
	}
	//alert("startRowIndex: "+startRowIndex+", endRowIndex: "+endRowIndex);

	for( var r=startRowIndex; r<=endRowIndex; r++ ){
		var rowId = grid.getRowId(r);
		for( var c=0; c<grid.getColumnsNum(); c++ ){
			var num = 0;
			for( var ce=c+1; ce<grid.getColumnsNum(); ce++ ){
				var cell = grid.cells(rowId, ce);
				var value = cell.getOrgValue();
				//alert("value: "+value);
				if( value=="#cspan" ) {
					num++;
				}else {
					break;
				}
			}

			if( num>0 ) {
				//alert("ok, rowId: "+rowId+", c: "+c+", num: "+num);
				grid.setColspan(rowId, c, num+1);
			}
			c += num;
		}
	}
}

function doResizeGrid(colIdx, width, g) {
	if(g.getSortingState()[0]){
		g.setSortImgPos();
	}
	return true;
}

function doResizeEndGrid(g) {
	var GRID_HEADER_HEIGHT = 32;
	var SCROLL_BAR_WIDTH = 16;

	// スクロールバーがあるかどうかチェック
	var gboxh = g.objBox.scrollHeight + GRID_HEADER_HEIGHT;
	var genth = parseInt((g.entBox.style.height));

	var isScroll;
	if(gboxh > genth){
		isScroll = true;
	} else {
		isScroll = false;
	}

	// カラム幅を計算し、最終カラムの幅を調整する。
	var colwidth = parseInt(g.entBox.style.width);
	var  size = g.getColumnsNum();
	for(var i=0; i<(size-1); i++){
		var tmp = g.getColWidth(i);
		colwidth -= tmp;
	}
	colwidth -= 2*(size+1);
	if( colwidth < 30 ) {
		colwidth = 30;
	}

	var margin = 0;
	if( size < 5 ) {
		margin = 10;
	}else if( size < 7 ) {
		margin = 6;
	}else if( size < 9 ) {
		margin = 2;
	}

	if( isScroll ) {
		g.setColWidth((size-1), colwidth-margin);
	}else {
		g.setColWidth((size-1), colwidth+SCROLL_BAR_WIDTH-margin);
	}

	//g.setSizes();
	if(g.getSortingState()[0]){
		g.setSortImgPos();
	}
	return true;
}

/**
 * Gridマネージャ
 *
 * @class BlnderGridManager
 */
function BlnderGridManager(){
	this.grids = {};

	var self = this;
	this.addTarget = function(grid) {
		if (grid) {
			self.grids[grid.tagId] = grid;
		}
	};
	this.removeTarget = function(grid) {
		if (grid) {
			delete self.grids[grid.tagId];
		}
	};
}

/**
 * フラグがtrueの場合、BlnderGridManagerで関連済みのGridから
 * 選択中以外のセルの選択状態を解除する
 */
BlnderGridManager.CLEAR_MANAGED_GRID_SELECTION = true;

/**
 * BlnderGridManagerId
 */
BlnderGridManager.BLENDER_GRID_MANAGER_ID = "gridManager";

/*
Copyright MITSUBISHI Elec.
*/
